import cn from 'classnames'
import { GetSignatureId } from 'legacy/lut/classes/helpers/partner360/CommitmentHelper'
import { usePartnerId } from 'legacy/lut/classes/helpers/partner360/usePartnerId'
import { usePartnerInfo } from 'legacy/lut/classes/helpers/partner360/usePartnerInfo'
import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import { IFormPartnerBasicInfo } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { formatMoneyInteger } from 'legacy/lut/components/widgets/public/partner360/helpers/formatMoneyInteger'
import { requestGlobalPartnerData } from 'legacy/lut/features/globalPartner'
import { useJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { Fragment, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { TranslationMode } from 'cng-common/features/translations/configs'
import { useSafetyTranslation } from 'cng-common/features/translations/hooks'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'
import { Button } from 'core-components/library/button'
import { Checkbox, Switch } from 'core-components/library/checkbox'
import { LoaderOverlay } from 'core-components/library/loader'
import { ModalDialog } from 'core-components/library/modalDialog'
import { NotificationController } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'
import { Controller, ValidationStatus } from 'core-components/library/validation'
import { URLContext } from 'core/routes/urlController'
import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import Logger from 'core/utils/Logger'
import { ActualsTypeButtons, useActualsTypes } from 'partner360/components/actualsTypeButtons'
import { CurrenciesButtons, useCurrencies } from 'partner360/components/currenciesButtons'
import { SellTypeButtons } from 'partner360/components/sellTypeButtons/SellTypeButtons'
import { isSubCategoryMandatory } from 'partner360/entities/planning'
import { requestCompletenessStatusForFinSobSidePanelItem } from 'partner360/features/finSobSidePanel/api/requestCompletenessStatusForFinSobSidePanelItem'
import { isSectionSettingOn } from 'partner360/helpers/sectionSettings/isSectionSettingOn'
import { useChangeNotApplicable } from 'partner360/hooks/finSob/useChangeNotApplicable'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { selectPartnerAccess } from '../../../../../../features/partner360/configuration'
import {
  selectSectionSettings,
  updateSectionSettings,
} from '../../../../../../features/partner360/sectionSettings'
import { createSectionSettingsPatch } from '../../../../../../features/partner360/sectionSettings/models/iSectionSettingsState'
import { useAppDispatch } from '../../../../../../hooks/useAppDispatch'
import { useUserRoles } from '../../../../../../hooks/useUserRoles'
import { CommitmentChangeDialog } from '../../commitment/CommitmentChangeDialog'
import { CommentEditorIcon } from '../../components/CommentEditorIcon'
import { CommentIcon } from '../../components/CommentIcon'
import { GrowField } from '../../components/GrowField'
import { ApplyButton } from '../../editors/ApplyButton'
import { useTargetsUrlDeps } from '../../editors/useTargetsUrlDeps'
import { HelpSection } from '../../helpButton'
import { HintComponent } from '../../HintComponent'
import { useMarketShare } from '../../hooks/useMarketShare'
import { IJBPPlanning, IJBPPlanningItem } from '../../models/IJBPPlanning'
import { NotApplicableWidget } from '../../notApplicableWidget/NotApplicable'
import { TypeChangeDialog } from '../../programsManagementAdmin/TypeChangeDialog'
import { applyJBPPlanning } from '../../services/applyJBPPlanning'
import { cleanPlanningItemForApi } from '../../services/cleanPlanningItemForApi'
import { WidgetHeaderWithHelpButton } from '../../widgetHeader'
import { WidgetHeader } from '../../widgetHeader/WidgetHeader'
import { CategoryTitle } from '../components/categoryTitle/CategoryTitle'
import { fieldWrapper } from '../components/fieldWrapper/fieldWrapper'
import { FloatingNumberInput } from '../components/floatingNumberInput'
import { MandatoryField } from '../components/mandatoryField/MandatoryField'
import { PartnersCompletenessField } from '../components/partnersCompletenessField/PartnersCompletenessField'
import { SplitPlanningSwitcher } from '../components/splitPlanningSwitcher/SplitPlanningSwitcher'
import { WarningField } from '../components/warningField/WarningField'
import {
  actualsColor,
  COMPLETENESS_INFO_FIN_SOB_PLAN_FIELD,
  FIELD_STATE_DISABLED,
  FIELD_STATE_HIGHLIGHT,
  HIDE_SOB_FOR_COUNTRY,
  IS_ALWAYS_SHOW_ACTUALS,
  IS_ALWAYS_SHOW_SOB,
  IS_HIDE_QUOTA_GROW,
  IS_QUARTER_DEFAULT,
  IS_SHOW_COMPOSED_REPORT_EXPANDED_WARNING,
  IS_SHOW_INFORMATION_BANNERS,
  IS_SHOW_NOT_APPLICABLE,
  IS_SHOW_NULL,
  IS_SHOW_PARTNERS_COMPLETENESS_FOR_ALL_ROWS,
  IS_SHOW_PARTNERS_COMPLETENESS_FOR_CONTRACTUAL_PLAN,
  IS_SHOW_PARTNERS_COMPLETENESS_FOR_SUB_CATEGORIES,
  IS_SHOW_PREV_RECALC_ACTUALS,
  IS_USE_LEVEL_ICON,
  IS_USE_RECALC_PLANS_FROM_BOTTOM_FUNCTIONALITY,
  MANDATORY_CATEGORY,
  MANDATORY_CATEGORY_ALWAYS_EXPANDED,
  OVERALL_CATEGORY,
  P360_FIRST_FYEAR,
  PERCENT_FRACTION_DIGITS,
  PLAN_REQUEST_FOR_PREV_YEARS,
  PLAN_STATE_FIELD,
  PLANNING_BY_FY_FQ,
  PLANNING_COL_NUMBER,
  PLANNING_URL_DEPS,
  quotaColor,
  SOB_FRACTION_DIGITS,
  SOB_NEW_LOGIC_FYEAR,
  SOB_STATE_FIELD,
  SST_MANDATORY_LOGIC_FYEAR,
} from '../config'
import { IS_SHOW_PREV_PREV_FYEAR } from '../config'
import { ConfirmNotApplicableDialog } from '../dialogs/confirmNotApplicableDialog/ConfirmNotApplicableDialog'
import { ConfirmSwitchersChangeDialog } from '../dialogs/confirmSwitchersChangeDialog/ConfirmSwitchersChangeDialog'
import { EditCommentDialog } from '../dialogs/editCommentDialog/EditCommentDialog'
import { PartnersCompletenessDialog } from '../dialogs/partnersCompletenessDialog/PartnersCompletenessDialog'
import { PartnersWithoutSoBDialog } from '../dialogs/partnersWithoutSoBDialog/PartnersWithoutSoBDialog'
import { calcDiff } from '../helpers/calcDiff'
import { calcPercentage } from '../helpers/calcPercentage'
import { checkProportion } from '../helpers/checkProportion'
import { cleanQuartersAndFY } from '../helpers/cleanQuartersAndFY'
import { getCategoryNAField } from '../helpers/getCategoryNAField'
import { getCompletenessItem } from '../helpers/getCompletenessItem'
import { getFieldName } from '../helpers/getFieldName'
import { getGtmPoints } from '../helpers/getGtmPoints'
import { getIsCollapsedCategory } from '../helpers/getIsCollapsedCategory'
import { getIsCollapsedL3Category } from '../helpers/getIsCollapsedL3Category'
import { getIsNoPlan } from '../helpers/getIsNoPlan'
import { getNAField } from '../helpers/getNAField'
import { getPlanValue } from '../helpers/getPlanValue'
import { getSubCategoriesWithPlanCount } from '../helpers/getSubCategoriesWithPlanCount'
import { getTwoYearsSum } from '../helpers/getTwoYearsSum'
import { getIsExpandedByFlags } from '../helpers/partnerFlags/getIsExpandedByFlags'
import { getMandatoryLinesInCategoryCount } from '../helpers/partnerFlags/getMandatoryLinesInCategoryCount'
import { isContractualsByFlag } from '../helpers/partnerFlags/isContractualsByFlag'
import { isPartnerFlagActive } from '../helpers/partnerFlags/isPartnerFlagActive'
import {
  IPreparePlanningItems,
  preparePlanningItems,
} from '../helpers/prepareData/preparePlanningItems'
import { setFySobByQuarters } from '../helpers/setFySobByQuarters'
import { setFYTotalByQuarters } from '../helpers/setFYTotalByQuarters'
import { setItemValuesUniversal } from '../helpers/setItemValuesUniversal'
import { setQuarterByFYTotal } from '../helpers/setQuarterByFYTotal'
import { TSettingsSuffix, TSplitType, TSType } from '../models'
import { IFieldProps } from '../models/IFieldProps'
import { IPartnersCompleteness } from '../models/IPartnersCompleteness'

import { CategoryHeaderStandard } from './components/categoryHeader/CategoryHeaderStandard'
import { CategorySubTitleStandard } from './components/categorySubTitle/CategorySubTitleStandard'
import { MapRowStandard } from './components/mapRow/MapRowStandard'
import { ICategoryPlanningStandardProps } from './models/ICategoryPlanningStandardProps'

import styles from './CategoryPlanningStandard.module.scss'
import stylesCompensation from 'legacy/lut/components/widgets/public/partner360/Compensation.module.scss'
import stylesTable from 'legacy/lut/components/widgets/public/partner360/PartnerDevicesInfo.module.scss'

interface ICommentEditor {
  index: number
  year: number
  q: number
  comment: string
}

export const CategoryPlanningStandard = (props: ICategoryPlanningStandardProps) => {
  /** -------------------- States ----------------------- */

  const [actualsItems, setActualsItems] = useState<IJBPPlanningItem[]>([])
  const [actualsNoSplitItems, setActualsNoSplitItems] = useState<IJBPPlanningItem[]>([])
  const [editCommentEditor, setCommentEditor] = useState<ICommentEditor>()
  const [isApplyingChanges, setIsApplyingChanges] = useState(false)
  const [isCollapseAllowed, setIsCollapseAllowed] = useState<boolean>(true)
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true)
  const [isDataLoaded, setIsDataLoaded] = useState(false)
  const [isDataPresent, setIsDataPresent] = useState(false)
  const [isUnitsMandatory, setIsUnitsMandatory] = useState<boolean>(false)
  const [hideIfEmpty, setHideIfEmpty] = useState(false)
  const [quotaItems, setQuotaItems] = useState<IJBPPlanningItem[]>([])
  const [reservedActuals, setReservedActuals] = useState<IJBPPlanningItem[]>([])
  const [reservedTargets, setReservedTargets] = useState<IJBPPlanningItem[]>([])
  const [targetsItems, setTargetsItems] = useState<IJBPPlanningItem[]>([])
  const [targetsNoSplitItems, setTargetsNoSplitItems] = useState<IJBPPlanningItem[]>([])
  const [targetsRollupItems, setTargetsRollupItems] = useState<IJBPPlanningItem[]>([])
  const [actualsRollupItems, setActualsRollupItems] = useState<IJBPPlanningItem[]>([])
  const [targetsPartnerCountItems, setTargetsPartnerCountItems] = useState<IJBPPlanningItem[]>([])
  const [validationStatus, setValidationStatus] = useState(ValidationStatus.Invalid)

  const [isRecalcPlans, setIsRecalcPlans] = useState(false)
  const [isShowAllSplits, setIsShowAllSplits] = useState(false)
  const [isShowConfirmNotApplicableDialog, setIsShowConfirmNotApplicableDialog] = useState(false)
  const [isShowConfirmSwitchersChangeDialog, setIsShowConfirmSwitchersChangeDialog] =
    useState(false)
  const [isShowPartnersWithoutSoBDialog, setIsShowPartnersWithoutSoBDialog] = useState(false)
  const [isShowRateDialog, setIsShowRateDialog] = useState(false)
  const [isShowSignDialog, setIsShowSignDialog] = useState(false)
  const [isShowSignDialogNA, setIsShowSignDialogNA] = useState(false)
  const [partnersWithoutSoBIds, setPartnersWithoutSoBIds] = useState('')
  const [partnersCompleteness, setPartnersCompleteness] = useState<IPartnersCompleteness>()
  const [splitType, setSplitType] = useState<TSplitType>('Total')

  const fQuarters = props.periodFQuarters || [1, 2, 3, 4]
  const { isPartnerUser } = useUserRoles()

  /** -------------------- Selectors ----------------------- */

  const isEditMode = useSelector(selectPublishingMode)
  const translationMode = useSelector(selectTranslationMode)
  const sectionSettings = useSelector(selectSectionSettings)

  /** -------------------- Hooks ----------------------- */
  const dispatch = useAppDispatch()
  const context = useContext(URLContext)
  const t = useSafetyTranslation()
  const partnerId = usePartnerId(props.widgetParams, props.pid)
  const {
    fyear: partnerFYear,
    partnerInfo,
    canEditPartner,
    buttonCurrType,
    triggerCompleteness,
  } = usePartnerInfo({ partnerId })

  const changeNotApplicableHndl = useChangeNotApplicable({
    partnerId,
    fYear: partnerFYear,
  })

  const { jbpSettings } = useJbpSettings()
  const fixedComposedReportFYear = props.composedReportFYear ?? jbpSettings.currentFYear
  const fixedQuarterlyBusinessReviewFYear =
    props.quarterlyBusinessReviewFYear ?? jbpSettings.currentFYear
  const composedReportFYear = props.composedReportMode ? fixedComposedReportFYear : partnerFYear
  const fyear = props.isQuarterlyBusinessReviewMode
    ? fixedQuarterlyBusinessReviewFYear
    : composedReportFYear
  const { activeCurrency: partnerCurrency } = useCurrencies()
  const { actualsType, actualsTypes, onChangeActualsType } = useActualsTypes()
  const { isDistributor, isRegionalDistributor } = useSelector(selectPartnerAccess)
  const { marketShareData } = useMarketShare({
    partnerId,
    fyear,
    programType: buttonCurrType,
    section: 'jbp-gtm-priorities',
  })
  const { signed, dropSignature } = GetSignatureId(
    partnerId,
    COMPLETENESS_INFO_FIN_SOB_PLAN_FIELD,
    buttonCurrType
  )

  /** -------------------- Variables ----------------------- */

  const isTranslationMode = translationMode === TranslationMode.Edit
  const currentCat = props.dataSetInfo.category

  const currency = useMemo(() => {
    const qbrCurrency = props.quarterlyBusinessReviewCurrency || 'USD'

    return !props.isQuarterlyBusinessReviewMode ? partnerCurrency : qbrCurrency
  }, [partnerCurrency, props.isQuarterlyBusinessReviewMode, props.quarterlyBusinessReviewCurrency])

  const currentValueType = useMemo(() => {
    let calcualtedValueType = actualsType

    if (props.isQuarterlyBusinessReviewMode) {
      calcualtedValueType =
        (props.quarterlyBusinessReviewNetNdp as ActualsValueTypes) || ActualsValueTypes.Ndp
    }

    return calcualtedValueType
  }, [actualsType, props.isQuarterlyBusinessReviewMode, props.quarterlyBusinessReviewNetNdp])

  const isTargetsChanged = targetsItems.some((el) => !!el.IsChanged || !!el.IsChangedSoB)
  const isTargetsValuesChanged = targetsItems.some((el) => !!el.IsChanged)
  const isActualsChanged = actualsItems.some((el) => !!el.IsChanged || !!el.IsChangedSoB)
  const isDataChanged = isTargetsChanged || isActualsChanged
  const isShowUnits = !!props.dataSetInfo.IsUnitsAvailable
  const catNAField = getCategoryNAField(currentCat)
  const isOverallOnly = !props.formats.filter(
    (el) => !!el.SubCategory && el.SubCategory !== OVERALL_CATEGORY
  ).length
  const isTargetsNotChanged =
    JSON.stringify(
      targetsItems.map((el) => {
        return { ...el, IsChanged: 0, IsChangedSoB: 0 }
      })
    ) ===
    JSON.stringify(
      reservedTargets.map((el) => {
        return { ...el, IsChanged: 0, IsChangedSoB: 0 }
      })
    )
  const isTargetsSignedNotChanged =
    JSON.stringify(
      targetsItems.map((el) => {
        return { ...el, IsChanged: 0, IsChangedSoB: 0, Comment: '' }
      })
    ) ===
    JSON.stringify(
      reservedTargets.map((el) => {
        return { ...el, IsChanged: 0, IsChangedSoB: 0, Comment: '' }
      })
    )
  const isActualsNotChanged =
    JSON.stringify(
      actualsItems.map((el) => {
        return { ...el, IsChanged: 0, IsChangedSoB: 0 }
      })
    ) ===
    JSON.stringify(
      reservedActuals.map((el) => {
        return { ...el, IsChanged: 0, IsChangedSoB: 0 }
      })
    )
  const isNotChanged = isTargetsNotChanged && isActualsNotChanged
  const isTargetSignedChanged = isTargetsChanged && !isTargetsSignedNotChanged
  const isNeedToShowSignNADialog = signed > -1
  const isNeedToShowSignDialog = isNeedToShowSignNADialog && isTargetSignedChanged
  const isTargetValuesReallyChanged = isTargetsValuesChanged && !isTargetsNotChanged
  const isHideSoB = partnerInfo?.CountryCode === HIDE_SOB_FOR_COUNTRY

  const isCurrencyChanged = !!props.originalCurrency && props.originalCurrency !== currency
  const isActualsValueTypeChanged =
    !!props.originalActualsValueType && props.originalActualsValueType !== currentValueType

  const isSwitchersChanged =
    isTargetValuesReallyChanged && (isCurrencyChanged || isActualsValueTypeChanged)
  const isRetail = buttonCurrType === ProgramTypes.Retail

  const isFixedCollapsed = isCollapsed
  const isComposedSobDisabled = false

  const isMandatoryByFlag = isSubCategoryMandatory(
    partnerInfo?.PartnerFlags || '',
    props.dataSetInfo.MandatoryByFlags,
    sectionSettings,
    true
  )
  const isNotApplicableAllowed =
    props.dataSetInfo.MandatoryType !== MANDATORY_CATEGORY &&
    props.dataSetInfo.MandatoryType !== MANDATORY_CATEGORY_ALWAYS_EXPANDED &&
    !isMandatoryByFlag.isMandatory

  const isEditAllowed =
    !props.readOnly &&
    isEditMode &&
    !props.composedReportMode &&
    !props.isQuarterlyBusinessReviewMode &&
    canEditPartner &&
    (!isRegionalDistributor || props.isRegionalPlanning) &&
    (!props.globalCategory || !!props.globalCategory.IsEditable) &&
    actualsType !== ActualsValueTypes.UTNet

  const isShowComposedModeSwitchers = !!props.composedReportMode

  const shortPrevFY = (fyear || 2000) - 2001
  const showPrevTargetsParams = [{ key: '{prevFY}', value: shortPrevFY.toString() }]

  const isShowCurrencyCtrl = !props.dataSetInfo.Settings?.HideCurrencyCtrl
  const isShowNetNdpCtrl = !props.dataSetInfo.Settings?.HideNetNdpCtrl
  const isShowActualsCtrl =
    !props.dataSetInfo.Settings?.HideActualsCtrl && !props.composedReportMode
  const isShowQuotaCtrl =
    !props.dataSetInfo.Settings?.HideQuotaCtrl &&
    !props.composedReportMode &&
    !props.isQuarterlyBusinessReviewMode
  const isShowCurrencyBlock = !props.dataSetInfo.Settings?.HideCurrencyBlock
  const isShowSalesTypeCtrl =
    !props.dataSetInfo.Settings?.HideSalesTypeCtrl &&
    !props.composedReportMode &&
    !props.isQuarterlyBusinessReviewMode

  const isShowPrevTargetsCtrl = !props.isQuarterlyBusinessReviewMode

  const isShowCtrlBeforeActuals = isShowCurrencyCtrl || isShowNetNdpCtrl
  const isShowActualsCtrlFirst = !isShowCtrlBeforeActuals && isShowActualsCtrl
  const isShowDistributorCtrlFirst =
    !isShowCtrlBeforeActuals && !isShowActualsCtrl && !isShowQuotaCtrl

  const isOveralledCategory =
    props.formats.length === 1 && !props.formats.some((el) => el.SubCategory === OVERALL_CATEGORY)
  const isShowComposedReportCollapsedWarning =
    IS_SHOW_COMPOSED_REPORT_EXPANDED_WARNING &&
    props.composedReportMode &&
    !isRecalcPlans &&
    !isFixedCollapsed &&
    !isOveralledCategory

  const isMandatoryByFlagLogic = useMemo(() => fyear >= SST_MANDATORY_LOGIC_FYEAR, [fyear])
  const isSoBNewLogic = useMemo(() => fyear >= SOB_NEW_LOGIC_FYEAR, [fyear])

  // Show PrevFY and Cals Actuals logic
  const isShowPrePreYear = IS_SHOW_PREV_PREV_FYEAR && !props.composedReportMode
  const isShowCalcActuals =
    IS_SHOW_PREV_RECALC_ACTUALS &&
    fyear > jbpSettings.fYear &&
    jbpSettings.currentFQuarter === 4 &&
    !props.composedReportMode
  const planningColSpan = useMemo(
    () => PLANNING_COL_NUMBER + (isShowPrePreYear ? 1 : 0) + (isShowCalcActuals ? 1 : 0),
    [isShowPrePreYear, isShowCalcActuals]
  )

  const isUseContractuals = useMemo(() => {
    const flags = partnerInfo?.PartnerFlags || ''
    const isContrByFlag = isContractualsByFlag(flags, props.partnerFlagsState)

    return (
      buttonCurrType === ProgramTypes.CorePrint && (props.isContractualPlanning || isContrByFlag)
    )
  }, [
    buttonCurrType,
    props.isContractualPlanning,
    partnerInfo?.PartnerFlags,
    props.partnerFlagsState,
  ])

  const isEditFixed = useMemo(
    () => isEditAllowed && (!isUseContractuals || splitType !== 'Total'),
    [isEditAllowed, isUseContractuals, splitType]
  )
  const isShowAllSplitsCtrl = isUseContractuals && splitType === 'Total'
  const isShowContrTrans = isShowAllSplitsCtrl && isShowAllSplits
  const isNoSplitPlans = !isUseContractuals || splitType === 'Total'

  // Category title and tip keys
  const offeringName = buttonCurrType || props.dataSetInfo.ProgramType
  const offeringNameLower = offeringName.replace(/\s/g, '').toLowerCase()
  const currentCatLower = currentCat.replace(/\s/g, '').toLowerCase()
  const globalCategoryKey = (props.globalCategory?.GlobalCategory || '').replace(/jbp-/g, '')
  const globalShortKey = !globalCategoryKey
    ? `jbp-${offeringNameLower}`
    : `jbp-${offeringNameLower}-${globalCategoryKey}`
  const globalKey = `${globalShortKey}-${currentCatLower}`
  const headerKey = !partnerInfo?.IsGlobal ? currentCat : globalKey
  const globalCategoryTipPrefix = !partnerInfo?.IsGlobal ? '' : globalShortKey

  // Header key
  const headerComposedSuffix = props.composedReportMode ? '-composed' : '-editor'
  const headerSuffix = props.isQuarterlyBusinessReviewMode ? '-qbr' : headerComposedSuffix
  const categoryHeaderKey = `${headerKey}${headerSuffix}`
  const categoryUnitsHeaderKey = `${categoryHeaderKey}-units`

  const isShowInformationBanners =
    IS_SHOW_INFORMATION_BANNERS && !props.composedReportMode && !props.isQuarterlyBusinessReviewMode
  const isShowMapRow =
    !isPartnerUser && !props.composedReportMode && !props.isQuarterlyBusinessReviewMode

  const isShowFutureYears = useMemo(() => {
    return props.isShowFutureYearsPlans && fyear > 2024 && !props.isQuarterlyBusinessReviewMode
  }, [fyear, props.isQuarterlyBusinessReviewMode, props.isShowFutureYearsPlans])

  /** -------------------- Methods ----------------------- */

  const { updatePendingData, registrUrlDeps } = useTargetsUrlDeps({
    resetChanged: () => {
      setTargetsItems(reservedTargets)
      setActualsItems(reservedActuals)
    },
    apply: () => applyChangesHandler(),
    changed: isDataChanged,
    isNotChanged,
    urlDeps: PLANNING_URL_DEPS,
  })

  registrUrlDeps(context)

  const getL3Index = (format: IFormActualsTargetsSettings) => {
    let idx = 0
    let subCategory = ''
    let isFormatFound = false

    props.formats
      .filter((el) => !!el.L3Category)
      .filter((el) => el.Category === format.Category)
      .forEach((el) => {
        if (subCategory !== el.SubCategory && !isFormatFound) {
          subCategory = el.SubCategory
          if (el.SubCategory === format.SubCategory) {
            isFormatFound = true
          } else {
            idx++
          }
        }
      })

    return idx
  }

  const isCategoryNA = useMemo(() => {
    let isNotApplicable = isNotApplicableAllowed

    if (partnerInfo) {
      const sectionSetting = sectionSettings[catNAField]
      if (sectionSetting == undefined || sectionSetting == null) {
        // sectionSettings Not defined
        if (hideIfEmpty && !isDataPresent) {
          return true
        } else {
          // Not hideIfEmpty or dataPresent > use Original behave
          isNotApplicable = isNotApplicable && isSectionSettingOn(sectionSetting)
        }
      } else {
        // sectionSettings defined > use Original behave
        isNotApplicable = isNotApplicable && isSectionSettingOn(sectionSetting)
      }
    }

    return (
      !IS_SHOW_NOT_APPLICABLE &&
      isNotApplicable &&
      !props.composedReportMode &&
      !props.isQuarterlyBusinessReviewMode
    )
  }, [
    catNAField,
    sectionSettings,
    hideIfEmpty,
    isDataPresent,
    isNotApplicableAllowed,
    partnerInfo,
    props.composedReportMode,
    props.isQuarterlyBusinessReviewMode,
  ])

  const isShowNotApplicableMessage = useMemo(() => {
    return !IS_SHOW_NOT_APPLICABLE && isNotApplicableAllowed && isCategoryNA
  }, [isNotApplicableAllowed, isCategoryNA])

  const isShowNotApplicableWidget = useMemo(() => {
    return IS_SHOW_NOT_APPLICABLE && isNotApplicableAllowed
  }, [isNotApplicableAllowed])

  const isOn = (key: string, type: TSettingsSuffix, defaultValue: boolean = false) => {
    let settingValue = defaultValue

    if (partnerInfo) {
      const field = getNAField(key, type)
      const val = sectionSettings[field]
      if (val !== undefined && val !== null) {
        settingValue = isSectionSettingOn(val)
      }
    }

    return settingValue
  }

  const isShowApplySection = !isCategoryNA && isEditAllowed
  const isShowQbrUnits =
    !!props.isQuarterlyBusinessReviewMode && !!props.isQuarterlyBusinessReviewUnits
  const isShowUnitsOnPlanning = isShowUnits && !isCategoryNA && isOn(currentCat, 'units')
  const isShowUnitsSection =
    isShowUnitsOnPlanning || isShowQbrUnits || !!props.dataSetInfo.IsHideFinancial
  const isShowPlanningSection =
    !props.dataSetInfo.IsHideFinancial &&
    (!props.isQuarterlyBusinessReviewMode || !props.isQuarterlyBusinessReviewUnits)
  const isShowApplyBeforeUnits = isShowApplySection && isShowUnitsSection && isShowPlanningSection
  const isShowControlsBeforeUnits = !!props.dataSetInfo.IsHideFinancial && isEditAllowed

  const preparePlanningData = useCallback(async () => {
    setIsDataLoaded(false)
    setValidationStatus(ValidationStatus.Valid)

    const isComposedReport = !!props.composedReportMode
    const isQuarterlyBusinessReview = !!props.isQuarterlyBusinessReviewMode

    let filteredData = props.planningData.filter(
      (el) =>
        (el.ProgramTypes === buttonCurrType || isComposedReport || isQuarterlyBusinessReview) &&
        el.Category === currentCat &&
        !el.IsTotal &&
        (!props.globalCategory || el.GlobalCategory === props.globalCategory.GlobalCategory)
      // operator: dataSetInfo.SummaryProgram ? Operator.CONTAINS : Operator.EQUAL,
      // value: dataSetInfo.category.replace('-overall', ''),
    )

    const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

    if (!isIgnorePartnerId) {
      // Show distributor's group data for Regional Distributor:
      // Get data from all Partner in group, Except Regional Distributor
      if (isRegionalDistributor && !props.isRegionalPlanning) {
        filteredData = filteredData.filter((el) => el.PartnerId !== partnerId)
      } else {
        filteredData = filteredData.filter((el) => el.PartnerId === partnerId)
      }
    }

    // Separation into Target, Actuals, Quota data
    const rawTargets = filteredData.filter(
      (el) =>
        !!el.IsTarget && (!isComposedReport || !el.IsNoSplit) && !el.IsRollUp && !el.IsPartnerCount
    )
    const rawActuals = filteredData.filter(
      (el) =>
        !!el.IsActuals && (!isComposedReport || !el.IsNoSplit) && !el.IsRollUp && !el.IsPartnerCount
    )
    const rawQuota = filteredData.filter(
      (el) =>
        !!el.IsQuota && (!isComposedReport || !el.IsNoSplit) && !el.IsRollUp && !el.IsPartnerCount
    )
    // Separation into NoSplit, RollUp, PartnerCount data
    const rawTargetsNoSplit = filteredData.filter(
      (el) => !!el.IsNoSplit && !!el.IsTarget && !el.IsRollUp && !el.IsPartnerCount
    )
    const rawActualsNoSplit = filteredData.filter(
      (el) => !!el.IsNoSplit && !!el.IsActuals && !el.IsRollUp && !el.IsPartnerCount
    )
    const rawTargetsRollup = filteredData.filter((el) => !!el.IsRollUp && !!el.IsTarget)
    const rawActualsRollup = filteredData.filter((el) => !!el.IsActuals && !!el.IsRollUp)
    const rawTargetsPartnerCount = filteredData.filter((el) => !!el.IsPartnerCount && !!el.IsTarget)

    const futureYears = isShowFutureYears ? 2 : 0
    const lastFYear = fyear + futureYears

    const commonParams: IPreparePlanningItems = {
      planningSettings: props.formats,
      source: rawTargets,
      partnerId: partnerId,
      fyear: fyear,
      lastFYear: lastFYear,
      isActuals: 0,
      isDirect: 0,
      isTarget: 1,
      isQuota: 0,
      isComposedReport: isComposedReport,
      isNoSplit: 0,
      isRollUp: 0,
      isTotal: 0,
      isPartnerCount: 0,
      globalCategory: globalCategoryKey,
    }

    // Prepare Target, Actuals, Quota data
    const targetsItems = preparePlanningItems(commonParams)
    const actualsItems = preparePlanningItems({
      ...commonParams,
      source: rawActuals,
      isTarget: 0,
      isActuals: 1,
    })
    const quotaItems = preparePlanningItems({
      ...commonParams,
      source: rawQuota,
      isTarget: 0,
      isQuota: 1,
    })
    // Prepare NoSplit, RollUp, PartnerCount data
    const actualsNoSplitItems = preparePlanningItems({
      ...commonParams,
      source: rawActualsNoSplit,
      isTarget: 0,
      isActuals: 1,
      isNoSplit: 1,
    })
    const targetsNoSplitItems = preparePlanningItems({
      ...commonParams,
      source: rawTargetsNoSplit,
      isNoSplit: 1,
    })
    const targetsRollupItems = preparePlanningItems({
      ...commonParams,
      source: rawTargetsRollup,
      isRollUp: 1,
    })
    const actualsRollupItems = preparePlanningItems({
      ...commonParams,
      source: rawActualsRollup,
      isTarget: 0,
      isActuals: 1,
      isRollUp: 1,
    })
    const targetsPartnerCountItems = preparePlanningItems({
      ...commonParams,
      source: rawTargetsPartnerCount,
      isPartnerCount: 1,
    })

    setTargetsItems(targetsItems)
    setActualsItems(actualsItems)
    setQuotaItems(quotaItems)
    setActualsNoSplitItems(actualsNoSplitItems)
    setTargetsNoSplitItems(targetsNoSplitItems)
    setTargetsRollupItems(targetsRollupItems)
    setActualsRollupItems(actualsRollupItems)
    setTargetsPartnerCountItems(targetsPartnerCountItems)

    setReservedTargets([
      ...targetsItems.map((el) => {
        return { ...el }
      }),
    ])
    setReservedActuals([
      ...actualsItems.map((el) => {
        return { ...el }
      }),
    ])

    if (rawTargets.filter((el) => el.FYear === fyear).length) {
      const isCollapsedCategory = getIsCollapsedCategory(targetsItems, fyear)
      setIsCollapsed(isCollapsedCategory && isCollapseAllowed)
    }

    // Begin: calculate hideIfEmpty, dataNotEmpty
    let hideEmptyData: boolean = false
    if (props.formats) {
      props.formats.map((el) => {
        if (!!el.HideIfEmpty && !hideIfEmpty) {
          setHideIfEmpty(true)
          hideEmptyData = true
        }
      })
    }

    if (hideEmptyData) {
      let isDataPresent = false
      targetsItems.map((el) => {
        if (el.IsDataPresent) {
          isDataPresent = true
        }
      })
      setIsDataPresent(isDataPresent)
    }
    // End: calculate hideIfEmpty, dataNotEmpty

    if (props.composedReportMode) {
      let isAcknowledgedDataPresent = false
      targetsItems.map((el) => {
        if (el.IsAcknowledgedDataPresent) {
          isAcknowledgedDataPresent = true
        }
      })
      if (!isAcknowledgedDataPresent) {
        props.setIsShowOnlyCompletedPlans(false, false)
      }
    }

    setIsDataLoaded(true)
  }, [
    buttonCurrType,
    currentCat,
    fyear,
    hideIfEmpty,
    isCollapseAllowed,
    isRegionalDistributor,
    partnerId,
    props.composedReportMode,
    props.formats,
    props.isRegionalPlanning,
    props.planningData,
  ])

  const getRowSum = (settingsIndex: number, isGetUnits: boolean) => {
    let sum = 0

    const sumParam = {
      formats: props.formats,
      settingsIndex,
      items: actualsItems,
      fyear,
      isGetUnits,
      isAddContractual: false,

      actualsType,
      isDirect: false,

      isComposedCompletedPlans: false,
      isComposedSob: false,
    }

    sum += getTwoYearsSum({ ...sumParam, items: actualsItems })
    sum += getTwoYearsSum({ ...sumParam, items: targetsItems })
    sum += getTwoYearsSum({ ...sumParam, items: quotaItems })

    return sum
  }

  /**
   * Is Overall Value for Current FY Exist and Not changed
   */
  const isOverallValueNotChanged = (partnerInfo: IFormPartnerBasicInfo | undefined): boolean => {
    let isNotChanged = false

    if (partnerInfo) {
      const valueTypeSuffix = currentValueType.toLowerCase() === 'ndp' ? 'Ndp' : 'Net'
      const currencySuffix = !currency || currency === 'USD' ? 'Usd' : 'Lc'
      const originalValueField = `OfficeHWPlan${valueTypeSuffix}${currencySuffix}`
      const originalValue = partnerInfo[originalValueField]
      if (originalValue || originalValue === 0) {
        const overallSettings = props.formats.filter(
          (el) =>
            el.ProgramType === buttonCurrType &&
            el.Category === currentCat &&
            (!el.SubCategory || el.SubCategory === OVERALL_CATEGORY)
        )
        if (overallSettings.length) {
          const overallSetting = overallSettings[0]

          const sType = '' // Total
          const fq = 5 // FY Value
          const isUnits = false
          const isSoB = false
          const isDirect = false

          const newValue = getPlanValue(
            overallSetting,
            targetsItems,
            partnerId,
            fyear,
            fq,
            currentValueType,
            isUnits,
            currency,
            isFixedCollapsed,
            sType,
            isSoB,
            isDirect,
            props.isShowOnlyCompletedPlans,
            props.isShowComposedSoB,
            isRecalcPlans,
            props.composedReportMode,
            props.isQuarterlyBusinessReviewMode
          )

          if (newValue === originalValue) {
            isNotChanged = true
          }
        }
      }
    }

    return isNotChanged
  }

  const applyChanges = async (data: IJBPPlanningItem[]) => {
    setIsDataLoaded(false)
    let isPlanningSaved = false

    try {
      const fromFYear = Math.max(fyear - PLAN_REQUEST_FOR_PREV_YEARS, P360_FIRST_FYEAR)
      const isUSD = !currency || currency === 'USD'
      const cleanTargets = cleanPlanningItemForApi(data, fyear, isFixedCollapsed)
      const cleanActuals = cleanPlanningItemForApi(actualsItems, fyear, isFixedCollapsed)
      const isTargetsChanged = cleanTargets.some((el) => !!el.IsChanged || !!el.IsChangedSoB)
      const cleanData = [...cleanTargets, ...cleanActuals]
      const json = JSON.stringify(cleanData)
      const isQuarterPlanning =
        !!props.dataSetInfo.IsOnlyQuarterlyPlanning ||
        isOn(currentCat, 'quarter', IS_QUARTER_DEFAULT)

      const applyResponse = await applyJBPPlanning<IJBPPlanning>(
        partnerId,
        fyear,
        fromFYear,
        buttonCurrType,
        isQuarterPlanning,
        isUSD,
        currentValueType,
        isRegionalDistributor,
        json
      )
      isPlanningSaved = true

      if (partnerInfo?.IsGlobal) {
        dispatch(requestGlobalPartnerData({ partnerId, fYear: fyear }))
      }

      if (props.onApply) {
        const newData: IJBPPlanning[] = applyResponse?.Rows || []
        props.onApply(newData)
      }

      if (isTargetsChanged) {
        if (!isOverallValueNotChanged(partnerInfo)) {
          await dropSignature('Financial & SOB Targets')
        }

        try {
          await triggerCompleteness()
        } catch (error) {
          Logger.error(error)
          NotificationController.showWarning({
            message:
              'Planning data was saved, but completeness could not be updated. Please refresh the page later.',
          })
        }
      }

      dispatch(
        requestCompletenessStatusForFinSobSidePanelItem({
          partnerId,
          programType: buttonCurrType,
          fYear: fyear,
          category: currentCat,
        })
      )

      if (partnerInfo?.OfficeHWPlanNdpUsd && props?.onReloadPartnerInfo) {
        props.onReloadPartnerInfo()
      }
    } catch (error) {
      Logger.error(error)

      if (isPlanningSaved) {
        NotificationController.showWarning({
          message:
            'Planning data was saved, but post-save updates failed. Please refresh the page later.',
        })
      } else {
        NotificationController.showError({
          message: 'Planning data was not saved. Please try again.',
        })
      }
    } finally {
      setIsDataLoaded(true)

      if (isPlanningSaved) {
        props.onSaveSuccess?.()
      }
    }
  }

  const getValue = (
    settingsIndex: number,
    type: 'actuals' | 'targets' | 'quota',
    fy: number,
    fq: number,
    isUnits: boolean,
    sType: TSType,
    isSoB: boolean,
    isNoSplit: boolean,
    isRollUp: boolean,
    fieldName?: string
  ): number => {
    let items = !isNoSplit ? targetsItems : targetsNoSplitItems

    if (type === 'actuals') {
      items = !isNoSplit ? actualsItems : actualsNoSplitItems
    }
    if (type === 'quota') {
      items = quotaItems
    }
    if (isRollUp) {
      if (type === 'actuals') {
        items = actualsRollupItems
      } else {
        items = targetsRollupItems
      }
    }

    const isDirect = false

    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]
      return getPlanValue(
        setting,
        items,
        partnerId,
        fy,
        fq,
        currentValueType,
        isUnits,
        currency,
        isFixedCollapsed,
        sType,
        isSoB,
        isDirect,
        props.isShowOnlyCompletedPlans,
        props.isShowComposedSoB,
        isRecalcPlans,
        props.composedReportMode,
        props.isQuarterlyBusinessReviewMode,
        fieldName
      )
    } else {
      return 0
    }
  }

  const getCalcActuals = (
    settingsIndex: number,
    fy: number,
    isUnits: boolean,
    sType: TSType,
    isSoB: boolean,
    isNoSplit: boolean
  ): number => {
    const actualQ1 = getValue(
      settingsIndex,
      'actuals',
      fy,
      1,
      isUnits,
      sType,
      isSoB,
      isNoSplit,
      false
    )
    const actualQ2 = getValue(
      settingsIndex,
      'actuals',
      fy,
      2,
      isUnits,
      sType,
      isSoB,
      isNoSplit,
      false
    )
    const actualQ3 = getValue(
      settingsIndex,
      'actuals',
      fy,
      3,
      isUnits,
      sType,
      isSoB,
      isNoSplit,
      false
    )
    const targetQ4 = getValue(
      settingsIndex,
      'targets',
      fy,
      4,
      isUnits,
      sType,
      isSoB,
      isNoSplit,
      false
    )

    return (actualQ1 || 0) + (actualQ2 || 0) + (actualQ3 || 0) + (targetQ4 || 0)
  }

  const isRateValid = (): boolean => {
    let result = true

    // Recalc Overall row Fy by Q or Q by FY
    const overallSettings = props.formats.filter(
      (el) =>
        el.ProgramType === buttonCurrType &&
        el.Category === currentCat &&
        (!el.SubCategory || el.SubCategory === OVERALL_CATEGORY)
    )
    if (overallSettings.length) {
      const overallSetting = overallSettings[0]

      const fq = PLANNING_BY_FY_FQ
      const isUnits = false
      const sTotal = '' // Total
      const isSoB = false
      const isDirect = false

      const preActuals = getPlanValue(
        overallSetting,
        actualsItems,
        partnerId,
        fyear - 1,
        fq,
        currentValueType,
        isUnits,
        currency,
        isFixedCollapsed,
        sTotal,
        isSoB,
        isDirect,
        props.isShowOnlyCompletedPlans,
        props.isShowComposedSoB,
        isRecalcPlans,
        props.composedReportMode,
        props.isQuarterlyBusinessReviewMode
      )
      const currTargets = getPlanValue(
        overallSetting,
        targetsItems,
        partnerId,
        fyear,
        fq,
        currentValueType,
        isUnits,
        currency,
        isFixedCollapsed,
        sTotal,
        isSoB,
        isDirect,
        props.isShowOnlyCompletedPlans,
        props.isShowComposedSoB,
        isRecalcPlans,
        props.composedReportMode,
        props.isQuarterlyBusinessReviewMode
      )

      result = checkProportion([
        {
          item1: currTargets,
          item2: preActuals,
        },
      ])
    }

    return result
  }

  const getValueFrom = (
    settingsIndex: number,
    type: 'actuals' | 'targets' | 'quota',
    fy: number,
    fq: number,
    isNoSplit: boolean,
    isRollUp: boolean,
    fieldName: 'Comment' = 'Comment'
  ): string => {
    let result = ''

    let items = !isNoSplit ? targetsItems : targetsNoSplitItems
    if (type === 'actuals') {
      items = !isNoSplit ? actualsItems : actualsNoSplitItems
    }
    if (type === 'quota') {
      items = quotaItems
    }
    if (isRollUp) {
      if (type === 'actuals') {
        items = actualsRollupItems
      } else {
        items = targetsRollupItems
      }
    }

    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]

      const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

      // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
      const sourceData = items.filter(
        (el) =>
          (el.PartnerId === partnerId || isIgnorePartnerId) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy &&
          el.FQuarter === fq
      )

      if (sourceData.length >= 1) {
        result = sourceData[0][fieldName] ?? ''
      } else {
        // error in data
      }
    }

    return result
  }

  const setComment = (settingsIndex: number, value: string, fy: number, fq: number) => {
    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]

      const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

      const items = targetsItems
      // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
      const sourceData = items.filter(
        (el) =>
          (el.PartnerId === partnerId || isIgnorePartnerId) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy &&
          el.FQuarter === fq
      )

      if (sourceData.length >= 1) {
        // Comment not changing SoB
        const newItem = { ...sourceData[0], Comment: value, IsChanged: 1 }
        const data = [...items]
        const idx = items.indexOf(sourceData[0])
        data.splice(idx, 1, newItem)

        setTargetsItems([...data])
      } else {
        // error in data
      }
    }
  }

  const setIsL3Collapsed = (sIdx: number, newValue: boolean, fy: number) => {
    if (!props.composedReportMode) {
      const { isUpdated, updatedItems } = setIsL3CollapsedInternal(targetsItems, sIdx, newValue, fy)
      if (isUpdated) {
        setTargetsItems(updatedItems)
      }
    } else {
      // For right re-calculation in composedReportMode

      const { isUpdated: isUpdTarCurFY, updatedItems: updTarCurFY } = setIsL3CollapsedInternal(
        targetsItems,
        sIdx,
        newValue,
        fy
      )
      const { isUpdated: isUpdTarPreFY, updatedItems: updTargets } = setIsL3CollapsedInternal(
        updTarCurFY,
        sIdx,
        newValue,
        fy - 1
      )
      if (isUpdTarCurFY || isUpdTarPreFY) {
        setTargetsItems(updTargets)
      }

      const { isUpdated: isUpdActCurFY, updatedItems: updActCurFY } = setIsL3CollapsedInternal(
        actualsItems,
        sIdx,
        newValue,
        fy
      )
      const { isUpdated: isUpdActPreFY, updatedItems: updActuals } = setIsL3CollapsedInternal(
        updActCurFY,
        sIdx,
        newValue,
        fy - 1
      )
      if (isUpdActCurFY || isUpdActPreFY) {
        setActualsItems(updActuals)
      }
    }
  }

  const setIsL3CollapsedInternal = (
    items: IJBPPlanningItem[],
    sIdx: number,
    newValue: boolean,
    fy: number
  ): { isUpdated: boolean; updatedItems: IJBPPlanningItem[] } => {
    if (sIdx < props.formats.length) {
      const setting = props.formats[sIdx]

      const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

      // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
      const sourceData = items.filter(
        (el) =>
          (el.PartnerId === partnerId || isIgnorePartnerId) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy
        //el.FQuarter === fq // All quarters
      )

      if (sourceData.length >= 1) {
        const data = [...items]

        sourceData.forEach((currItem) => {
          const newItem = {
            ...currItem,
            IsCollapsed: newValue ? 1 : 0,
            IsNoPlan: newValue ? currItem.IsNoPlan : 0,
            // IsCollapsed not changing SoB
            IsChanged: 1,
          }
          const idx = items.indexOf(currItem)
          data.splice(idx, 1, newItem)
        })

        return { isUpdated: true, updatedItems: [...data] }
      } else {
        // error in data
      }
    }

    return { isUpdated: false, updatedItems: items }
  }

  const setIsNoPlan = (sIdx: number, value: boolean, fy: number, isOvr: boolean, sType: TSType) => {
    if (sIdx < props.formats.length) {
      const setting = props.formats[sIdx]

      const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

      const items = targetsItems
      // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
      const targetForUpdate = items.filter(
        (el) =>
          (el.PartnerId === partnerId || isIgnorePartnerId) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          //(el.SubCategory === setting.SubCategory || !!sType) && // All SubCategories rows for Contractual
          //(el.L3Category === setting.L3Category || !!sType) && // All L3 rows for Contractual
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy
        //el.FQuarter === fq // All quarters
      )

      if (targetForUpdate.length >= 1) {
        let data = [...items]

        const isNoPlanField = sType ? 'IsNoPlanContractual' : 'IsNoPlan'

        targetForUpdate.forEach((currItem) => {
          // IsNoPlan not changing SoB
          const newItem = { ...currItem, [isNoPlanField]: value ? 1 : 0, IsChanged: 1 }
          const idx = items.indexOf(currItem)
          data.splice(idx, 1, newItem)
        })

        if (!value) {
          // Update only IsNoPlan* fields
          setTargetsItems([...data])
        } else {
          // Clean Targets Contractual for all FQ (and as result for FY)
          let isSoB = false
          const isUnits = false
          const isClean = !!sType
          data = setValue(
            sIdx,
            '0',
            'targets',
            fy,
            1,
            isUnits,
            isOvr,
            sType,
            isSoB,
            false,
            data,
            isClean
          )
          data = setValue(
            sIdx,
            '0',
            'targets',
            fy,
            2,
            isUnits,
            isOvr,
            sType,
            isSoB,
            false,
            data,
            isClean
          )
          data = setValue(
            sIdx,
            '0',
            'targets',
            fy,
            3,
            isUnits,
            isOvr,
            sType,
            isSoB,
            false,
            data,
            isClean
          )
          data = setValue(
            sIdx,
            '0',
            'targets',
            fy,
            4,
            isUnits,
            isOvr,
            sType,
            isSoB,
            false,
            data,
            isClean
          )

          if (!sType) {
            // Clean Targets SoB for FY and FQ
            const fyQ = PLANNING_BY_FY_FQ
            isSoB = true
            data = setValue(
              sIdx,
              '0',
              'targets',
              fy,
              fyQ,
              isUnits,
              isOvr,
              sType,
              isSoB,
              false,
              data
            )
            data = setValue(sIdx, '0', 'targets', fy, 1, isUnits, isOvr, sType, isSoB, false, data)
            data = setValue(sIdx, '0', 'targets', fy, 2, isUnits, isOvr, sType, isSoB, false, data)
            data = setValue(sIdx, '0', 'targets', fy, 3, isUnits, isOvr, sType, isSoB, false, data)
            data = setValue(sIdx, '0', 'targets', fy, 4, isUnits, isOvr, sType, isSoB, false, data)
          }
        }
      } else {
        // error in data
      }
    }
  }

  const setValue = (
    settingsIndex: number,
    value: string,
    type: 'actuals' | 'targets' | 'quota',
    fy: number,
    fq: number,
    isUnits: boolean,
    isOverall: boolean,
    sType: TSType,
    isSoB: boolean,
    isNoSplit: boolean,
    itemsForUpdate?: IJBPPlanningItem[],
    isCleanChild?: boolean
  ) => {
    let items = !isNoSplit ? targetsItems : targetsNoSplitItems
    let reserv = reservedTargets
    if (itemsForUpdate && itemsForUpdate.length && type === 'targets') {
      items = itemsForUpdate
    } else {
      if (type === 'actuals') {
        items = !isNoSplit ? actualsItems : actualsNoSplitItems
        reserv = reservedActuals
      }
      if (type === 'quota') {
        items = quotaItems
      }
    }
    let data = [...items]

    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]

      const cat = setting.Category
      const l3Cat = setting.L3Category
      const isL3Overall = l3Cat === OVERALL_CATEGORY
      const isL3 = !!l3Cat
      const isL3DetailRow = isL3 && !isL3Overall

      const fieldProps = {
        actualsType: currentValueType,
        isUnits,
        currency,
        sType,
        isSoB,
        isDirect: false,
      }

      const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

      // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
      const sourceData = items.filter(
        (el) =>
          (el.PartnerId === partnerId || isIgnorePartnerId) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy &&
          el.FQuarter === fq
      )
      if (sourceData.length >= 1) {
        const newItem = setItemValuesUniversal(
          sourceData[0],
          value,
          fieldProps,
          cat,
          true,
          props.translationFactors
        )

        const idx = items.indexOf(sourceData[0])
        data.splice(idx, 1, newItem)

        if (type === 'actuals') {
          setActualsItems([...data])
        } else {
          setTargetsItems([...data])
        }

        if (!isSoB) {
          const isPlanningByFY = fq >= PLANNING_BY_FY_FQ
          if (isPlanningByFY) {
            data = setQuarterByFYTotal({
              items: data,
              reservedItems: reserv,
              setting,
              fieldProps,
              fy,
              type,
              setTargetsItems,
              setActualsItems,
              translationFactors: props.translationFactors,
            })
          } else {
            data = setFYTotalByQuarters({
              items: data,
              setting,
              fieldProps,
              fy,
              setTargetsItems,
              translationFactors: props.translationFactors,
            })
          }

          const isL3DetailRow = isL3 && !isL3Overall

          if (!isOverall || isL3DetailRow) {
            if (isL3DetailRow) {
              // Recalc L3 Category Overall
              data = setOverallTotal(data, setting, fieldProps, fy, fq, isL3DetailRow)

              // Recalc Overall row FY by Q or Q by FY
              const overallSettingsL3 = props.formats.filter(
                (el) =>
                  el.ProgramType === setting.ProgramType &&
                  el.Category === setting.Category &&
                  el.SubCategory === setting.SubCategory
              )

              if (overallSettingsL3.length) {
                const overallSet = overallSettingsL3[0]

                if (isPlanningByFY) {
                  data = setQuarterByFYTotal({
                    items: data,
                    reservedItems: reserv,
                    setting: overallSet,
                    fieldProps,
                    fy,
                    type,
                    setTargetsItems,
                    setActualsItems,
                    translationFactors: props.translationFactors,
                  })
                } else {
                  data = setFYTotalByQuarters({
                    items: data,
                    setting: overallSet,
                    fieldProps,
                    fy,
                    setTargetsItems,
                    translationFactors: props.translationFactors,
                  })
                }
              }
            }

            // Recalc Category Overall
            // TODO: Find Category Overall if currently edit L3 Overall
            data = setOverallTotal(data, setting, fieldProps, fy, fq, false)

            // Recalc Overall row Fy by Q or Q by FY
            const overallSettings = props.formats.filter(
              (el) =>
                el.ProgramType === setting.ProgramType &&
                el.Category === setting.Category &&
                (!el.SubCategory || el.SubCategory === OVERALL_CATEGORY)
            )

            if (overallSettings.length) {
              const overallSet = overallSettings[0]

              if (isPlanningByFY) {
                data = setQuarterByFYTotal({
                  items: data,
                  reservedItems: reserv,
                  setting: overallSet,
                  fieldProps,
                  fy,
                  type,
                  setTargetsItems,
                  setActualsItems,
                  translationFactors: props.translationFactors,
                })
              } else {
                data = setFYTotalByQuarters({
                  items: data,
                  setting: overallSet,
                  fieldProps,
                  fy,
                  setTargetsItems,
                  translationFactors: props.translationFactors,
                })
              }
            }
          }

          if (isOverall && !!sType && !!isCleanChild) {
            data = cleanQuartersAndFY({
              items: data,
              setting,
              fieldProps,
              fy,
              setTargetsItems,
              translationFactors: props.translationFactors,
            })
          }
        }

        // FY23 SoB algoritm
        if (
          isSoB &&
          !isSoBNewLogic &&
          fq >= PLANNING_BY_FY_FQ &&
          fy === fyear - 1 &&
          type === 'actuals'
        ) {
          data = setQuarterByFYTotal({
            items: data,
            reservedItems: reserv,
            setting,
            fieldProps,
            fy,
            type,
            setTargetsItems,
            setActualsItems,
            translationFactors: props.translationFactors,
          })
        }

        // FY24 SoB algoritm: 1. recalc FY SoB on Q SoB changed
        if (
          isSoB &&
          isSoBNewLogic &&
          fq !== PLANNING_BY_FY_FQ &&
          (fy === fyear || fy === fyear - 1) &&
          (type === 'actuals' || type === 'targets')
        ) {
          data = setFySobByQuarters(
            data,
            setting,
            fieldProps,
            fy,
            type,
            setActualsItems,
            setTargetsItems,
            jbpSettings.currentFYear,
            jbpSettings.currentFQuarter,
            props.translationFactors
          )
        }
        // FY24 SoB algoritm: 2. recalc FY SoB on Q Plan changed
        if (
          !isSoB &&
          isSoBNewLogic &&
          fq !== PLANNING_BY_FY_FQ &&
          fy === fyear &&
          type === 'targets'
        ) {
          const sobFieldProps = { ...fieldProps, isSoB: true }

          // 2.1 Recalc current row Fy by Q or Q by FY
          if (setting.IsSoBAvailable) {
            data = setFySobByQuarters(
              data,
              setting,
              sobFieldProps,
              fy,
              type,
              setActualsItems,
              setTargetsItems,
              jbpSettings.currentFYear,
              jbpSettings.currentFQuarter,
              props.translationFactors
            )
          }

          if (isL3DetailRow) {
            // 2.3 Recalc L3 Overall row Fy by Q or Q by FY
            const overallSettings = props.formats.filter(
              (el) =>
                el.ProgramType === setting.ProgramType &&
                el.Category === setting.Category &&
                el.SubCategory === setting.SubCategory &&
                el.L3Category === OVERALL_CATEGORY
            )

            if (overallSettings.length) {
              const overallSet = overallSettings[0]
              data = setFySobByQuarters(
                data,
                overallSet,
                sobFieldProps,
                fy,
                type,
                setActualsItems,
                setTargetsItems,
                jbpSettings.currentFYear,
                jbpSettings.currentFQuarter,
                props.translationFactors
              )
            }
          }

          // 2.3 Recalc Category Overall row Fy by Q or Q by FY
          const overallSettings = props.formats.filter(
            (el) =>
              el.ProgramType === setting.ProgramType &&
              el.Category === setting.Category &&
              (!el.SubCategory || el.SubCategory === OVERALL_CATEGORY)
          )

          if (overallSettings.length) {
            const overallSet = overallSettings[0]
            data = setFySobByQuarters(
              data,
              overallSet,
              sobFieldProps,
              fy,
              type,
              setActualsItems,
              setTargetsItems,
              jbpSettings.currentFYear,
              jbpSettings.currentFQuarter,
              props.translationFactors
            )
          }
        }

        //updatePendingData(data)
      } else {
        // error in data
      }
    }

    return data
  }

  const setOverallTotal = (
    items: IJBPPlanningItem[],
    setting: IFormActualsTargetsSettings,
    fieldProps: IFieldProps,
    fy: number,
    fq: number,
    isL3DetailRow: boolean
  ) => {
    const data = [...items]

    const fieldName = getFieldName(fieldProps)
    const cat = setting.Category

    const subCategoryForOverall = isL3DetailRow ? setting.SubCategory : OVERALL_CATEGORY

    const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

    const overallCatData = items.filter(
      (el) =>
        (el.PartnerId === partnerId || isIgnorePartnerId) &&
        el.ProgramTypes === setting.ProgramType &&
        el.Category === setting.Category &&
        // Only Category overall
        el.SubCategory === subCategoryForOverall &&
        (!isL3DetailRow || el.L3Category === OVERALL_CATEGORY) &&
        el.FYear === fy &&
        el.FQuarter === fq
    )

    if (overallCatData.length >= 1) {
      // Calc Total
      const subCategoryData = items.filter(
        (el) =>
          (el.PartnerId === partnerId || isIgnorePartnerId) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          // Only Sub-categories
          ((!isL3DetailRow && el.SubCategory !== OVERALL_CATEGORY) ||
            (isL3DetailRow && el.SubCategory === setting.SubCategory)) &&
          ((!isL3DetailRow && (!el.L3Category || el.L3Category === OVERALL_CATEGORY)) ||
            (isL3DetailRow && el.L3Category !== OVERALL_CATEGORY)) &&
          el.FYear === fy &&
          el.FQuarter === fq
      )

      let total = 0
      subCategoryData.forEach((el) => {
        total += Number(el[fieldName] || 0)
      })

      // Set Total
      const newItem = setItemValuesUniversal(
        overallCatData[0],
        total,
        fieldProps,
        cat,
        false,
        props.translationFactors
      )

      const idx = items.indexOf(overallCatData[0])
      data.splice(idx, 1, newItem)

      setTargetsItems([...data])
    }

    return data
  }

  const isTransactionalValid = () => {
    let isValid = true

    const isUnits = false
    const isSoB = false

    if (isUseContractuals && !isCategoryNA && isShowCurrencyBlock) {
      props.formats.forEach((format, idx) => {
        const subCat = format.SubCategory
        const isOverall = subCat === OVERALL_CATEGORY || !subCat

        if (!isFixedCollapsed || isOverall) {
          for (let q = 1; q <= 5; q++) {
            const currTargetsTotal = getValue(
              idx,
              'targets',
              fyear,
              q,
              isUnits,
              '',
              isSoB,
              false,
              false
            ) // Total
            const currTargetsContr = getValue(
              idx,
              'targets',
              fyear,
              q,
              isUnits,
              'c',
              isSoB,
              false,
              false
            ) // Contractual
            const currTargetsTran = Number(currTargetsTotal || 0) - Number(currTargetsContr || 0)

            if (currTargetsTran < 0) {
              isValid = false
            }
          }
        }
      })
    }

    return isValid
  }

  const calcCollapseMode = useCallback(() => {
    if (partnerInfo) {
      // Set IsCollapsed for Currency planning
      const flags = props.partnerFlagsState
      const isFlagsExistInChildSettings = isPartnerFlagActive(flags, props.formats, currentCat)
      const isFlagsExistForUnits = isPartnerFlagActive(flags, props.formats, currentCat, true, true)
      const isCollapseAllowedSetting =
        props.dataSetInfo.MandatoryType !== MANDATORY_CATEGORY_ALWAYS_EXPANDED &&
        !isFlagsExistInChildSettings

      setIsCollapseAllowed(isCollapseAllowedSetting)
      setIsCollapsed((val) => val && isCollapseAllowedSetting && !isFlagsExistInChildSettings)

      // Set IsCollapsed for Units planning
      if (isFlagsExistForUnits && !isOn(currentCat, 'units')) {
        setSetting(currentCat, 'units')
      }
      setIsUnitsMandatory(isFlagsExistForUnits)
    }
  }, [partnerInfo, props.dataSetInfo.MandatoryType, props.partnerFlagsState])

  /** -------------------- User actions handlers ----------------------- */

  const toggleShowComposedSob = useCallback(() => {
    if (!props.isShowComposedSoB) {
      props.setIsShowOnlyCompletedPlans(true, true)

      // Collapse Category only if it Expanded and isCollapseAllowed
      if (!isFixedCollapsed && isCollapseAllowed) {
        setIsCollapsed(!isFixedCollapsed && isCollapseAllowed)
      }
    }
    props.setIsShowComposedSoB(!props.isShowComposedSoB)
  }, [props.isShowComposedSoB, isFixedCollapsed, isCollapseAllowed])

  const toggleIsCollapseCategory = useCallback(() => {
    setIsCollapsed(!isFixedCollapsed && isCollapseAllowed)
  }, [isFixedCollapsed, isCollapseAllowed])

  const onChangeNotApplicable = async () => {
    setIsDataLoaded(false)
    const isNotApplicable = isCategoryNA ? 0 : 1
    await changeNotApplicableHndl({
      isNotApplicable,
      categoryField: currentCat,
    })

    setIsDataLoaded(true)
  }

  const setSetting = async (key: string, type: TSettingsSuffix) => {
    setIsApplyingChanges(true)

    const isQuarter = type === 'quarter'
    const defaultValue = isQuarter ? IS_QUARTER_DEFAULT : false
    const currentValue = isOn(key, type, defaultValue)
    const newValue = currentValue ? 0 : 1
    const field = getNAField(key, type)
    const settingForUpdate = createSectionSettingsPatch({ [field]: newValue })

    await dispatch(
      updateSectionSettings({
        sectionSettings: settingForUpdate,
        flag: field,
        state: newValue,
        controlName: 'Planning',
      })
    ).unwrap()

    //await dropSignature('Financial & SOB Targets')

    setIsApplyingChanges(false)
  }

  const discardChanges = () => {
    setTargetsItems([
      ...reservedTargets.map((el) => {
        return { ...el, IsChanged: 0, IsChangedSoB: 0 }
      }),
    ])
    setActualsItems([
      ...reservedActuals.map((el) => {
        return { ...el, IsChanged: 0, IsChangedSoB: 0 }
      }),
    ])
    const isCollapsedCategory = getIsCollapsedCategory(reservedTargets, fyear)
    setIsCollapsed(isCollapsedCategory && isCollapseAllowed)
  }

  const applyChangesHandler = async () => {
    const isSignatureWillBeDropped =
      isNeedToShowSignDialog && !isOverallValueNotChanged(partnerInfo)

    if (!isRateValid()) {
      setIsShowRateDialog(true)
    } else if (isSignatureWillBeDropped) {
      setIsShowSignDialog(true)
    } else if (isSwitchersChanged) {
      setIsShowConfirmSwitchersChangeDialog(true)
    } else {
      await applyChanges(targetsItems)
    }
  }

  const confirmNotApplicable = async () => {
    setIsShowConfirmNotApplicableDialog(false)

    await onChangeNotApplicable()
  }

  const cancelNotApplicable = () => {
    setIsShowConfirmNotApplicableDialog(false)
  }

  /** -------------------- Render methods ----------------------- */

  const renderQ = (
    idx: number,
    isOverall: boolean,
    isL3Overall: boolean,
    q: number,
    isEditAllowed: boolean,
    isUnits: boolean,
    isNoPlan: boolean,
    isNoSplit: boolean,
    isRollUp: boolean
  ) => {
    const isEditFixed = isEditAllowed && (!isUseContractuals || splitType !== 'Total') && !isRollUp

    const isPrevYear = q < 0
    q = Math.abs(q)
    const isPlanningByFY = q >= PLANNING_BY_FY_FQ
    let futureYears = 0
    if (q > PLANNING_BY_FY_FQ) {
      futureYears = q - PLANNING_BY_FY_FQ
      q = PLANNING_BY_FY_FQ
    }
    const year = fyear - (isPrevYear ? 1 : 0) + futureYears

    const isShowPrevFY = !isPlanningByFY || (isShowPrePreYear && isPrevYear)
    const isShowPrevCalc = isPlanningByFY && isPrevYear
    const isShowPrevCalcActuals = isShowPrevCalc && isShowCalcActuals
    const isUseCalcActualsForYoY = isPlanningByFY && !isPrevYear && isShowCalcActuals

    const isSoB = false
    const sTotal = ''
    const rounding = isUnits ? '' : props.rounding

    if (isOverall || isL3Overall) {
      return renderQOverall(
        idx,
        isOverall,
        year,
        q,
        isUnits,
        isEditFixed,
        isPrevYear,
        isNoPlan,
        isNoSplit,
        isRollUp,
        futureYears
      )
    }

    const preActuals = getValue(
      idx,
      'actuals',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      false
    )
    const currActuals = getValue(idx, 'actuals', year, q, isUnits, sTotal, isSoB, isNoSplit, false)
    const preQuota = getValue(
      idx,
      'quota',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp
    )
    const currQuota = getValue(idx, 'quota', year, q, isUnits, sTotal, isSoB, isNoSplit, isRollUp)
    const preTargets = getValue(
      idx,
      'targets',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp
    )
    const currTargets = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp
    )
    const comment = getValueFrom(idx, 'targets', year, q, isNoSplit, isRollUp)
    const planState = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      PLAN_STATE_FIELD
    )

    const calActualsFy = isUseCalcActualsForYoY ? year - 1 : year
    const preActualsCalc = getCalcActuals(idx, calActualsFy, isUnits, sTotal, isSoB, isNoSplit)

    const gtmOnline = getGtmPoints(marketShareData, currTargets, year, 'Online')
    const gtmInstore = getGtmPoints(marketShareData, currTargets, year, 'Instore')
    const gtmOnlineFormatted = formatMoneyInteger(gtmOnline)
    const gtmInstoreFormatted = formatMoneyInteger(gtmInstore)

    const preActualsForYoY = isUseCalcActualsForYoY ? preActualsCalc : preActuals

    const yoyTargets = calcPercentage(preActualsForYoY, currTargets)
    const yoyActuals = calcPercentage(preActualsForYoY, currActuals)
    const yoyQuota = calcPercentage(preActualsForYoY, currQuota)

    const isQuarterPlanning =
      !!props.dataSetInfo.IsOnlyQuarterlyPlanning || isOn(currentCat, 'quarter', IS_QUARTER_DEFAULT)
    const isActiveColumns =
      (isQuarterPlanning && !isPlanningByFY) ||
      (!isQuarterPlanning && isPlanningByFY) ||
      !!futureYears
    const isEditCells = isEditFixed && isActiveColumns && !isPrevYear
    const isEditComment = isEditCells && !isPlanningByFY

    const setting = props.formats[idx]
    const isCategoryAlwaysOverall = !setting.SubCategory
    const isActiveRow =
      (isFixedCollapsed && isOverall) ||
      (!isFixedCollapsed && !isOverall) ||
      isCategoryAlwaysOverall

    const flags = partnerInfo?.PartnerFlags || ''
    const isMandatoryByFlag = isSubCategoryMandatory(
      flags,
      setting.MandatoryByFlags,
      sectionSettings,
      false
    )
    const isMandatoryUnitsByFlag = isSubCategoryMandatory(
      flags,
      setting.UnitsMandatoryByFlags,
      sectionSettings,
      false
    )
    const isShowMandatoryByFlag =
      (!isUnits && isMandatoryByFlag.isMandatory) || (isUnits && isMandatoryUnitsByFlag.isMandatory)
    const isShowMandatoryForCategory = isOverall || !isCollapseAllowed
    const isShowMandatoryCommon = isMandatoryByFlagLogic
      ? isShowMandatoryByFlag
      : isShowMandatoryForCategory
    const isShowMandatory = isShowMandatoryCommon && !isPrevYear && !props.composedReportMode

    const isShowZero = !IS_SHOW_NULL && isShowMandatory && Number(currTargets || 0) <= 0

    const isShowActualsCell = props.showActuals && !isRollUp
    const isShowQuota = props.showQuota && !isRollUp
    const isStripCol = !isActiveColumns && !isRollUp

    const isHidePrevTargets = !props.isShowPrevTargets
    const isHideCurrTargets = isHidePrevTargets && isPrevYear
    const isHideCurrTargetsYoY = isHideCurrTargets || (isNoPlan && !isPrevYear)

    const editorRender = () => {
      const isCellHighlighted = planState === FIELD_STATE_HIGHLIGHT && !(currTargets || 0)
      const isInputDisabled = planState === FIELD_STATE_DISABLED

      return (
        <>
          <MandatoryField value={(currTargets || 0).toFixed(0)} isShow={isShowMandatory} />
          <FloatingNumberInput
            floatLength={5}
            disabled={isInputDisabled}
            hasSpin={false}
            align="right"
            classes={{
              inputClasses: {
                root: cn(styles.cell, styles.cell__input, {
                  [styles.highlighted]: isCellHighlighted,
                }),
                content: styles.numberInput,
              },
            }}
            value={(currTargets || 0).toString()}
            onChange={(value) =>
              setValue(idx, value, 'targets', year, q, isUnits, isOverall, sTotal, isSoB, isNoSplit)
            }
            checkFn={ValidationHelper.checkNumber}
            maximumFractionDigits={0}
          />
        </>
      )
    }

    return (
      <>
        {isShowPrevFY && (
          <td
            className={cn(styles.colSeparator, {
              [styles.colStrip]: isStripCol,
            })}
          >
            <div className={cn(styles.itemWrapper)}>
              {/* TODO: for prev year also highlight? */}
              <div className={styles.itemValues}>
                <div className={styles.itemQuota}>
                  {isShowQuota && (
                    <>
                      {isHidePrevTargets ? (
                        <>&nbsp;</>
                      ) : (
                        <>
                          {fieldWrapper(
                            preQuota,
                            year - 1,
                            isRetail,
                            marketShareData,
                            'quota',
                            false,
                            0,
                            rounding
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                {isShowActualsCell && (
                  <div className={styles.itemActual}>
                    {fieldWrapper(
                      preActuals,
                      year - 1,
                      isRetail,
                      marketShareData,
                      'actuals',
                      false,
                      0,
                      rounding
                    )}
                  </div>
                )}
                <div
                  className={cn(styles.itemTarget, {
                    [styles.targetEdit]: isEditFixed && isActiveRow,
                  })}
                >
                  {isHidePrevTargets ? (
                    <>&nbsp;</>
                  ) : (
                    <>
                      {fieldWrapper(
                        preTargets,
                        year - 1,
                        isRetail,
                        marketShareData,
                        'targets',
                        false,
                        0,
                        rounding
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </td>
        )}
        {isShowPrevCalcActuals && (
          <td
            className={cn({
              [styles.colStrip]: isStripCol,
              [styles.colSeparator]: isPlanningByFY,
            })}
          >
            <div className={styles.itemWrapper}>
              <div className={styles.itemValues}>
                <div className={styles.itemQuota}>{isShowQuota && <>&nbsp;</>}</div>
                {isShowActualsCell && (
                  <div className={styles.itemActual}>
                    {fieldWrapper(
                      preActualsCalc,
                      year - 1,
                      isRetail,
                      marketShareData,
                      'actuals',
                      false,
                      0,
                      rounding
                    )}
                  </div>
                )}
                <div
                  className={cn(styles.itemTarget, {
                    [styles.targetEdit]: isEditFixed && isActiveRow && !isEditCells,
                  })}
                >
                  {isHideCurrTargets ? (
                    <>&nbsp;</>
                  ) : (
                    <>
                      {isNoPlan && !isPrevYear ? (
                        <Translation text="jbp-planning-no-plan" span />
                      ) : (
                        <>
                          <MandatoryField
                            value={(currTargets || 0).toFixed(0)}
                            isShow={isShowMandatory}
                          />
                          {fieldWrapper(
                            currTargets,
                            year,
                            isRetail,
                            marketShareData,
                            'targets',
                            isShowZero,
                            0,
                            rounding
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </td>
        )}
        <td
          className={cn({
            [styles.colStrip]: isStripCol,
            [styles.colSeparator]: isPlanningByFY && !isShowPrevCalcActuals,
            [styles.colSeparatorThin]: isPlanningByFY && isShowPrevCalcActuals,
          })}
        >
          <div className={styles.itemWrapper}>
            <div className={styles.itemValues}>
              <div className={styles.itemQuota}>
                {isShowQuota && (
                  <>
                    {isHideCurrTargets ? (
                      <span>&nbsp;</span>
                    ) : (
                      <>
                        {fieldWrapper(
                          currQuota,
                          year,
                          isRetail,
                          marketShareData,
                          'quota',
                          false,
                          0,
                          rounding
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
              {isShowActualsCell && (
                <div className={styles.itemActual}>
                  {fieldWrapper(
                    currActuals,
                    year,
                    isRetail,
                    marketShareData,
                    'actuals',
                    false,
                    0,
                    rounding
                  )}
                </div>
              )}
              <div
                className={cn(styles.itemTarget, {
                  [styles.targetEdit]: isEditFixed && isActiveRow && !isEditCells,
                })}
              >
                {!isEditCells && <CommentIcon tooltipText={comment} />}
                {!isEditCells ? (
                  <>
                    {isHideCurrTargets ? (
                      <>&nbsp;</>
                    ) : (
                      <>
                        {isNoPlan && !isPrevYear ? (
                          <Translation text="jbp-planning-no-plan" span />
                        ) : (
                          <>
                            <MandatoryField
                              value={(currTargets || 0).toFixed(0)}
                              isShow={isShowMandatory}
                            />
                            {fieldWrapper(
                              currTargets,
                              year,
                              isRetail,
                              marketShareData,
                              'targets',
                              isShowZero,
                              0,
                              rounding
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {isNoPlan && !isPrevYear ? (
                      <div className={styles.noPlanEditField}>
                        <Translation text="jbp-planning-no-plan" span />
                      </div>
                    ) : (
                      <>
                        {!isRetail ? (
                          editorRender()
                        ) : (
                          <Tooltip
                            tipContent={() => (
                              <span className={styles.tipContent}>
                                <span className={styles.tipLine}>
                                  <Translation text="jbp-gtm-priorities-online-tip" span />
                                  {gtmOnlineFormatted}
                                </span>
                                <br />
                                <span className={styles.tipLine}>
                                  <Translation text="jbp-gtm-priorities-instore-tip" span />
                                  {gtmInstoreFormatted}
                                </span>
                              </span>
                            )}
                          >
                            {editorRender()}
                          </Tooltip>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </td>
        <td
          className={cn({
            [styles.colStrip]: isStripCol,
          })}
        >
          <div className={styles.itemWrapper}>
            <div className={cn(styles.itemIcon, { [styles.itemEditIcon]: isEditCells })}>
              {isShowQuota && (
                <>
                  {isHideCurrTargetsYoY ? (
                    <span>&nbsp;</span>
                  ) : (
                    <GrowField
                      percent={yoyQuota}
                      isPaleColor={true}
                      isEmpty={IS_HIDE_QUOTA_GROW}
                      fractionDigits={PERCENT_FRACTION_DIGITS}
                    />
                  )}
                </>
              )}
              {isShowActualsCell && (
                <>
                  {isNoSplit ? (
                    <div>-</div>
                  ) : (
                    <GrowField
                      percent={yoyActuals}
                      isPaleColor={true}
                      fractionDigits={PERCENT_FRACTION_DIGITS}
                    />
                  )}
                </>
              )}
              {isNoSplit ? (
                <>-</>
              ) : (
                <div
                  className={cn({
                    [styles.itemInsteadCommentIcon]: isEditFixed && isActiveRow && !isEditComment,
                  })}
                >
                  {isHideCurrTargetsYoY ? (
                    <span>&nbsp;</span>
                  ) : (
                    <GrowField percent={yoyTargets} fractionDigits={PERCENT_FRACTION_DIGITS} />
                  )}
                </div>
              )}
              {isEditComment && (
                <CommentEditorIcon
                  comment={comment}
                  onClick={() => setCommentEditor({ index: idx, year, q, comment })}
                  isTranslationMode={isTranslationMode}
                />
              )}
            </div>
          </div>
        </td>
      </>
    )
  }

  const renderQContr = (
    idx: number,
    isOverall: boolean,
    q: number,
    isEditAllowed: boolean,
    isUnits: boolean,
    sType: 'c' | 't',
    isNoPlan: boolean
  ) => {
    const isEditFixed = isEditAllowed && (!isUseContractuals || splitType !== 'Total')
    const isNoPlanFixed = isNoPlan && sType !== 't'

    const isPrevYear = q < 0
    q = Math.abs(q)
    const isPlanningByFY = q >= PLANNING_BY_FY_FQ
    let futureYears = 0
    if (q > PLANNING_BY_FY_FQ) {
      futureYears = q - PLANNING_BY_FY_FQ
      q = PLANNING_BY_FY_FQ
    }
    const year = fyear - (isPrevYear ? 1 : 0) + futureYears

    const isShowPrevFY = !isPlanningByFY || (isShowPrePreYear && isPrevYear)
    const isShowPrevCalc = isPlanningByFY && isPrevYear
    const isShowPrevCalcActuals = isShowPrevCalc && isShowCalcActuals
    const isUseCalcActualsForYoY = isPlanningByFY && !isPrevYear && isShowCalcActuals

    const isSoB = false
    const isRollUp = false
    const rounding = isUnits ? '' : props.rounding

    const isCType = sType === 'c'
    const isContractualType = sType === 'c' || sType === 't'
    const isT = sType !== 'c' && sType !== 't'

    const preActualsTotal = getValue(
      idx,
      'actuals',
      year - 1,
      q,
      isUnits,
      '',
      isSoB,
      false,
      isRollUp
    ) // Total
    const currActualsTotal = getValue(idx, 'actuals', year, q, isUnits, '', isSoB, false, isRollUp) // Total
    const preTargetsTotal = getValue(
      idx,
      'targets',
      year - 1,
      q,
      isUnits,
      '',
      isSoB,
      false,
      isRollUp
    ) // Total
    const currTargetsTotal = getValue(idx, 'targets', year, q, isUnits, '', isSoB, false, isRollUp) // Total
    const preQuotaTotal = getValue(idx, 'quota', year - 1, q, isUnits, '', isSoB, false, isRollUp) // Total
    const currQuotaTotal = getValue(idx, 'quota', year, q, isUnits, '', isSoB, false, isRollUp) // Total

    const preActualsContr = getValue(
      idx,
      'actuals',
      year - 1,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp
    ) // Contractual
    const currActualsContr = getValue(idx, 'actuals', year, q, isUnits, 'c', isSoB, false, isRollUp) // Contractual
    const preTargetsContr = getValue(
      idx,
      'targets',
      year - 1,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp
    ) // Contractual
    const currTargetsContr = getValue(idx, 'targets', year, q, isUnits, 'c', isSoB, false, isRollUp) // Contractual
    const preQuotaContr = getValue(idx, 'quota', year - 1, q, isUnits, 'c', isSoB, false, isRollUp) // Contractual
    const currQuotaContr = getValue(idx, 'quota', year, q, isUnits, 'c', isSoB, false, isRollUp) // Contractual
    const planState = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp,
      PLAN_STATE_FIELD
    )

    const preActualsTran = Number(preActualsTotal || 0) - Number(preActualsContr || 0)
    const currActualsTran = Number(currActualsTotal || 0) - Number(currActualsContr || 0)
    const preTargetsTran = Number(preTargetsTotal || 0) - Number(preTargetsContr || 0)
    const currTargetsTran = Number(currTargetsTotal || 0) - Number(currTargetsContr || 0)
    const preQuotaTran = Number(preQuotaTotal || 0) - Number(preQuotaContr || 0)
    const currQuotaTran = Number(currQuotaTotal || 0) - Number(currQuotaContr || 0)

    const calActualsFy = isUseCalcActualsForYoY ? year - 1 : year
    const preActualsTotalCalc = getCalcActuals(idx, calActualsFy, isUnits, '', isSoB, false) // Total
    const preActualsContrCalc = getCalcActuals(idx, calActualsFy, isUnits, 'c', isSoB, false) // Contractual
    const preActualsTranCalc = Number(preActualsTotalCalc || 0) - Number(preActualsContrCalc || 0)
    const preActualsCalc = isCType ? preActualsContrCalc : preActualsTranCalc

    const preActualsContrForYoY = isUseCalcActualsForYoY ? preActualsContrCalc : preActualsContr
    const preActualsTranForYoY = isUseCalcActualsForYoY ? preActualsTranCalc : preActualsTran

    const yoyActualsContr = calcPercentage(preActualsContrForYoY, currActualsContr)
    const yoyActualsTran = calcPercentage(preActualsTranForYoY, currActualsTran)
    const yoyTargetsContr = calcPercentage(preActualsContrForYoY, currTargetsContr)
    const yoyTargetsTran = calcPercentage(preActualsTranForYoY, currTargetsTran)
    const yoyQuotaContr = calcPercentage(preActualsContrForYoY, currQuotaContr)
    const yoyQuotaTran = calcPercentage(preActualsTranForYoY, currQuotaTran)

    const setting = props.formats[idx]
    const isCategoryAlwaysOverall = !setting.SubCategory
    const isQuarterPlanning =
      !!props.dataSetInfo.IsOnlyQuarterlyPlanning || isOn(currentCat, 'quarter', IS_QUARTER_DEFAULT)
    const isActiveColumns =
      (isQuarterPlanning && !isPlanningByFY) ||
      (!isQuarterPlanning && isPlanningByFY) ||
      !!futureYears

    const l3Cat = setting.L3Category
    const isL3Overall = l3Cat === OVERALL_CATEGORY
    const isL3 = !!l3Cat
    const isL3Collapsed = getIsCollapsedL3Category(targetsItems, fyear, setting.SubCategory)

    const isL2ActiveRow =
      (isFixedCollapsed && isOverall) ||
      (!isFixedCollapsed && !isOverall) ||
      isCategoryAlwaysOverall
    const isL3ActiveRow =
      (isL3Collapsed && isL3Overall) || (!isL3Collapsed && !isL3Overall) || isCategoryAlwaysOverall
    const isActiveRow = isL3 ? isL3ActiveRow : isL2ActiveRow

    const isEditCells = isEditFixed && isActiveRow && isActiveColumns && !isPrevYear

    const isItemOverall = isOverall && !(props.showActuals || props.showQuota) && !isEditCells
    // TODO: Use only logic based on flags in FY24
    const isShowContractuals = buttonCurrType === ProgramTypes.CorePrint

    const flags = partnerInfo?.PartnerFlags || ''
    const isMandatoryByFlag = isSubCategoryMandatory(
      flags,
      setting.MandatoryByFlags,
      sectionSettings,
      false
    )
    const isMandatoryUnitsByFlag = isSubCategoryMandatory(
      flags,
      setting.UnitsMandatoryByFlags,
      sectionSettings,
      false
    )
    const isSkipTransactional =
      (!isUnits && isMandatoryByFlag.isSkipTransactional) ||
      (isUnits && isMandatoryUnitsByFlag.isSkipTransactional)
    const isShowMandatoryByFlag =
      (sType !== 't' || !isSkipTransactional) &&
      ((!isUnits && isMandatoryByFlag.isMandatory) ||
        (isUnits && isMandatoryUnitsByFlag.isMandatory))
    const isShowMandatoryForCategory = isOverall || !isCollapseAllowed
    const isShowMandatoryCommon = isMandatoryByFlagLogic
      ? isShowMandatoryByFlag
      : isShowMandatoryForCategory
    const isShowMandatory =
      isShowMandatoryCommon && !isPrevYear && !props.composedReportMode && isShowContractuals

    const isShowTransactionalWarning = isShowContractuals && !isPrevYear

    const value = isCType ? currTargetsContr : currTargetsTran

    const isShowZero = !IS_SHOW_NULL && isShowMandatory && Number(value || 0) <= 0

    const isHidePrevTargets = !props.isShowPrevTargets
    const isHideCurrTargets = isHidePrevTargets && isPrevYear
    const isHideCurrTargetsYoY = isHideCurrTargets || (isNoPlanFixed && !isPrevYear)

    const editorRender = () => {
      const isCellHighlighted = planState === FIELD_STATE_HIGHLIGHT && !(value || 0)
      const isInputDisabled = planState === FIELD_STATE_DISABLED

      return (
        <>
          <MandatoryField value={(value || 0).toFixed(0)} isShow={isShowMandatory} />
          <FloatingNumberInput
            floatLength={5}
            disabled={isInputDisabled}
            hasSpin={false}
            align="right"
            classes={{
              inputClasses: {
                root: cn(styles.cell, styles.cell__input, {
                  [styles.highlighted]: isCellHighlighted,
                }),
                content: styles.numberInput,
              },
            }}
            value={(value || 0).toString()}
            onChange={(value) => {
              // Orignal variant:
              // setValue(idx, value, 'targets', year, q, isUnits, isOverall, sType, isSoB, false)
              //
              //          Stored in DB    Save Value      And...
              // Total    yes             not edit
              // Cont     yes             OK              New Total = New Contractual + Transactional
              // Tran     NO (calc T-C)   [] Need to save Total = Contr + Tran AND Save Contr = PrevTotal - Tran
              //
              if (isCType) {
                // Value - new Contractual

                // Save New Contractual
                const d = setValue(
                  idx,
                  value,
                  'targets',
                  year,
                  q,
                  isUnits,
                  isOverall,
                  'c',
                  isSoB,
                  false
                )

                // New Total = New Contractual + Transactional
                const t = (Number(currTargetsTran || 0) + Number(value || 0)).toString()
                setValue(idx, t, 'targets', year, q, isUnits, isOverall, '', isSoB, false, d)
              } else {
                // Value - new Transactional

                // New Contr = Total - New Transactional
                const c = (Number(currTargetsTotal || 0) - Number(value || 0)).toString()
                setValue(idx, c, 'targets', year, q, isUnits, isOverall, 'c', isSoB, false)

                // New Total = Contractual + Transactional
                const newTotal = (Number(currTargetsContr || 0) + Number(value || 0)).toString()
                setValue(idx, newTotal, 'targets', year, q, isUnits, isOverall, '', isSoB, false)
              }
            }}
            checkFn={ValidationHelper.checkNumber}
            maximumFractionDigits={0}
          />
        </>
      )
    }

    return (
      <>
        {isShowPrevFY && (
          <td className={cn(styles.colSeparator, { [styles.colStrip]: !isActiveColumns })}>
            <div className={styles.itemWrapper}>
              <div className={styles.itemValues}>
                {isContractualType && (
                  <>
                    <div className={styles.itemQuota}>
                      {props.showQuota && (
                        <>
                          {isHidePrevTargets ? (
                            <>&nbsp;</>
                          ) : (
                            <>
                              {fieldWrapper(
                                isCType ? preQuotaContr : preQuotaTran,
                                year - 1,
                                isRetail,
                                marketShareData,
                                'quota',
                                false,
                                0,
                                rounding
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                    <div className={styles.itemActual}>
                      {props.showActuals &&
                        fieldWrapper(
                          isCType ? preActualsContr : preActualsTran,
                          year - 1,
                          isRetail,
                          marketShareData,
                          'actuals',
                          false,
                          0,
                          rounding
                        )}
                    </div>
                    <div
                      className={cn(styles.itemTarget, {
                        [styles.targetEdit]: isEditFixed && isActiveRow,
                      })}
                    >
                      {isHidePrevTargets ? (
                        <>&nbsp;</>
                      ) : (
                        <>
                          {fieldWrapper(
                            isCType ? preTargetsContr : preTargetsTran,
                            year - 1,
                            isRetail,
                            marketShareData,
                            'targets',
                            false,
                            0,
                            rounding
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
                {isT && (
                  <>
                    <div className={styles.itemQuota}>
                      {props.showQuota && (
                        <>
                          {isHidePrevTargets ? (
                            <>&nbsp;</>
                          ) : (
                            <>
                              {fieldWrapper(
                                preQuotaTran,
                                year - 1,
                                isRetail,
                                marketShareData,
                                'quota',
                                false,
                                0,
                                rounding
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                    <div className={styles.itemActual}>
                      {props.showActuals &&
                        fieldWrapper(
                          preActualsTran,
                          year - 1,
                          isRetail,
                          marketShareData,
                          'actuals',
                          false,
                          0,
                          rounding
                        )}
                    </div>
                    <div className={styles.itemTarget}>
                      {isHidePrevTargets ? (
                        <>&nbsp;</>
                      ) : (
                        <>
                          {fieldWrapper(
                            preTargetsTran,
                            year - 1,
                            isRetail,
                            marketShareData,
                            'targets',
                            false,
                            0,
                            rounding
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </td>
        )}
        {isShowPrevCalcActuals && (
          <td
            className={cn({
              [styles.colStrip]: !isActiveColumns,
              [styles.colSeparator]: isPlanningByFY,
            })}
          >
            <div className={cn(styles.itemWrapper, { [styles.itemOverall]: isItemOverall })}>
              <div className={styles.itemValues}>
                <div className={styles.itemQuota}>{props.showQuota && <>&nbsp;</>}</div>
                <div className={styles.itemActual}>
                  {fieldWrapper(
                    preActualsCalc,
                    year - 1,
                    isRetail,
                    marketShareData,
                    'actuals',
                    false,
                    0,
                    rounding
                  )}
                </div>
                <div
                  className={cn(styles.itemTarget, {
                    [styles.targetEdit]: isEditFixed && isActiveRow && !isEditCells,
                  })}
                >
                  {isHideCurrTargets ? (
                    <>&nbsp;</>
                  ) : (
                    <>
                      {isNoPlanFixed && !isPrevYear ? (
                        <Translation text="jbp-planning-no-plan" span />
                      ) : (
                        <>
                          <MandatoryField
                            value={(value || 0).toFixed(0)}
                            isShow={isShowMandatory}
                          />
                          {fieldWrapper(
                            value,
                            year,
                            isRetail,
                            marketShareData,
                            'targets',
                            isShowZero,
                            0,
                            rounding
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </td>
        )}
        <td
          className={cn({
            [styles.colStrip]: !isActiveColumns,
            [styles.colSeparator]: isPlanningByFY && !isShowPrevCalcActuals,
            [styles.colSeparatorThin]: isPlanningByFY && isShowPrevCalcActuals,
          })}
        >
          <div className={cn(styles.itemWrapper, { [styles.itemOverall]: isItemOverall })}>
            <div className={styles.itemValues}>
              {isContractualType && (
                <>
                  <div className={styles.itemQuota}>
                    {props.showQuota && (
                      <>
                        {isHideCurrTargets ? (
                          <span>&nbsp;</span>
                        ) : (
                          <>
                            {fieldWrapper(
                              isCType ? currQuotaContr : currQuotaTran,
                              year,
                              isRetail,
                              marketShareData,
                              'quota',
                              false,
                              0,
                              rounding
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                  {props.showActuals && (
                    <div className={styles.itemActual}>
                      {props.showActuals &&
                        fieldWrapper(
                          isCType ? currActualsContr : currActualsTran,
                          year,
                          isRetail,
                          marketShareData,
                          'actuals',
                          false,
                          0,
                          rounding
                        )}
                    </div>
                  )}
                  <div
                    className={cn(styles.itemTarget, {
                      [styles.targetEdit]: isEditFixed && isActiveRow && !isEditCells,
                    })}
                  >
                    {!isEditCells ? (
                      <>
                        {isHideCurrTargets ? (
                          <>&nbsp;</>
                        ) : (
                          <>
                            {isNoPlanFixed && !isPrevYear ? (
                              <Translation text="jbp-planning-no-plan" span />
                            ) : (
                              <>
                                <MandatoryField
                                  value={(value || 0).toFixed(0)}
                                  isShow={isShowMandatory}
                                />
                                {fieldWrapper(
                                  value,
                                  year,
                                  isRetail,
                                  marketShareData,
                                  'targets',
                                  isShowZero,
                                  0,
                                  rounding
                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {isNoPlanFixed && !isPrevYear ? (
                          <div className={styles.noPlanEditField}>
                            <Translation text="jbp-planning-no-plan" span />
                          </div>
                        ) : (
                          <>{editorRender()}</>
                        )}
                      </>
                    )}
                  </div>
                </>
              )}
              {isT && (
                <>
                  <div className={styles.itemQuota}>
                    {props.showQuota && (
                      <>
                        {isHideCurrTargets ? (
                          <span>&nbsp;</span>
                        ) : (
                          <>
                            {fieldWrapper(
                              currQuotaTran,
                              year,
                              isRetail,
                              marketShareData,
                              'quota',
                              false,
                              0,
                              rounding
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                  {props.showActuals && (
                    <div className={styles.itemActual}>
                      {props.showActuals &&
                        fieldWrapper(
                          currActualsTran,
                          year,
                          isRetail,
                          marketShareData,
                          'actuals',
                          false,
                          0,
                          rounding
                        )}
                    </div>
                  )}
                  <div className={styles.itemTarget}>
                    {isHideCurrTargets ? (
                      <>&nbsp;</>
                    ) : (
                      <>
                        <WarningField
                          value={(currTargetsTran || 0).toFixed(0)}
                          isShow={isShowTransactionalWarning}
                        />
                        {fieldWrapper(
                          currTargetsTran,
                          year,
                          isRetail,
                          marketShareData,
                          'targets',
                          false,
                          0,
                          rounding
                        )}
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </td>
        <td className={cn({ [styles.colStrip]: !isActiveColumns })}>
          <div className={styles.itemWrapper}>
            <div
              className={cn(
                styles.itemIcon,
                { [styles.itemOneIcon]: !props.showActuals },
                { [styles.itemEditIcon]: isEditCells }
              )}
            >
              {isContractualType && (
                <>
                  {props.showQuota && (
                    <>
                      {isHideCurrTargetsYoY ? (
                        <span>&nbsp;</span>
                      ) : (
                        <GrowField
                          percent={isCType ? yoyQuotaContr : yoyQuotaTran}
                          isPaleColor={true}
                          isEmpty={IS_HIDE_QUOTA_GROW}
                          fractionDigits={PERCENT_FRACTION_DIGITS}
                        />
                      )}
                    </>
                  )}
                  {props.showActuals && (
                    <GrowField
                      percent={isCType ? yoyActualsContr : yoyActualsTran}
                      isPaleColor={true}
                      fractionDigits={PERCENT_FRACTION_DIGITS}
                    />
                  )}
                  <div className={cn({ [styles.targetEdit]: isEditFixed && isActiveRow })}>
                    {isHideCurrTargetsYoY ? (
                      <span>&nbsp;</span>
                    ) : (
                      <GrowField
                        percent={isCType ? yoyTargetsContr : yoyTargetsTran}
                        fractionDigits={PERCENT_FRACTION_DIGITS}
                      />
                    )}
                  </div>
                </>
              )}
              {isT && (
                <>
                  {props.showQuota && (
                    <>
                      {isHideCurrTargetsYoY ? (
                        <span>&nbsp;</span>
                      ) : (
                        <GrowField
                          percent={yoyQuotaTran}
                          isPaleColor={true}
                          isEmpty={IS_HIDE_QUOTA_GROW}
                          fractionDigits={PERCENT_FRACTION_DIGITS}
                        />
                      )}
                    </>
                  )}
                  {props.showActuals && (
                    <GrowField
                      percent={yoyActualsTran}
                      isPaleColor={true}
                      fractionDigits={PERCENT_FRACTION_DIGITS}
                    />
                  )}
                  {isHideCurrTargetsYoY ? (
                    <span>&nbsp;</span>
                  ) : (
                    <GrowField percent={yoyTargetsTran} fractionDigits={PERCENT_FRACTION_DIGITS} />
                  )}
                </>
              )}
            </div>
          </div>
        </td>
      </>
    )
  }

  const renderSoB = (
    idx: number,
    isOverall: boolean,
    q: number,
    isEditAllowed: boolean,
    isUnits: boolean,
    isNoPlan: boolean,
    isRollUp: boolean
  ) => {
    const isPrevYear = q < 0
    q = Math.abs(q)
    const isPlanningByFY = q >= PLANNING_BY_FY_FQ
    let futureYears = 0
    if (q > PLANNING_BY_FY_FQ) {
      futureYears = q - PLANNING_BY_FY_FQ
      q = PLANNING_BY_FY_FQ
    }
    const year = fyear - (isPrevYear ? 1 : 0) + futureYears

    const isEditFixed = isEditAllowed && !isRollUp

    const isShowPrevFY = !isPlanningByFY || (isShowPrePreYear && isPrevYear)
    const isShowPrevCalc = isPlanningByFY && isPrevYear
    const isShowPrevCalcActuals = isShowPrevCalc && isShowCalcActuals

    const isShowActualsCell = props.showActuals && !isRollUp

    const isSoB = true
    const sTotal = ''

    const preActual = getValue(idx, 'actuals', year - 1, q, isUnits, sTotal, isSoB, false, isRollUp)
    const preTarget = getValue(idx, 'targets', year - 1, q, isUnits, sTotal, isSoB, false, isRollUp)
    const curActual = getValue(idx, 'actuals', year, q, isUnits, sTotal, isSoB, false, isRollUp)
    const curTarget = getValue(idx, 'targets', year, q, isUnits, sTotal, isSoB, false, isRollUp)
    const preActualState = getValue(
      idx,
      'actuals',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      SOB_STATE_FIELD
    )
    const preTargetState = getValue(
      idx,
      'targets',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      SOB_STATE_FIELD
    )
    const curActualState = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      SOB_STATE_FIELD
    )
    const curTargetState = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      SOB_STATE_FIELD
    )

    // TODO: is CompletenessItem need for RollUp?
    const preActCompleteness = getCompletenessItem({
      formats: props.formats,
      settingsIndex: idx,
      items: actualsItems,
      fy: year - 1,
      isSoB: true,
    })
    const preTarCompleteness = getCompletenessItem({
      formats: props.formats,
      settingsIndex: idx,
      items: targetsItems,
      fy: year - 1,
      isSoB: true,
    })
    const curActCompleteness = getCompletenessItem({
      formats: props.formats,
      settingsIndex: idx,
      items: actualsItems,
      fy: year,
      isSoB: true,
    })
    const curTarCompleteness = getCompletenessItem({
      formats: props.formats,
      settingsIndex: idx,
      items: targetsItems,
      fy: year,
      isSoB: true,
    })

    const yoyTarget = calcDiff(preActual, curTarget)
    const yoyActual = calcDiff(preActual, curActual)

    const isActiveColumns = true
    const isEditCellsActuals = isSoBNewLogic
      ? isEditFixed && (!isPlanningByFY || !!futureYears)
      : isEditFixed
    const isEditCellsTarget = isSoBNewLogic
      ? isEditFixed && (!isPlanningByFY || !!futureYears)
      : isEditFixed && !isPrevYear
    const isEditCellsActualsOnly = isEditCellsActuals && !isEditCellsTarget

    const setting = props.formats[idx]

    const cat = setting.Category
    const subCat = setting.SubCategory
    const l3Cat = setting.L3Category

    const flags = partnerInfo?.PartnerFlags || ''
    const isMandatoryByFlag = isSubCategoryMandatory(
      flags,
      setting.SOBMandatoryByFlags,
      sectionSettings,
      false
    )
    const isShowMandatory =
      isMandatoryByFlag.isMandatory && !isPrevYear && !isUnits && !props.composedReportMode

    const isShowZero = !IS_SHOW_NULL && isShowMandatory && Number(curTarget || 0) <= 0

    const isShowPreActCompletenessField =
      !!props.composedReportMode && !!preActCompleteness.partnersNotCompleted
    const isShowPreTarCompletenessField =
      !!props.composedReportMode && !!preTarCompleteness.partnersNotCompleted
    const isShowCurActCompletenessField =
      !!props.composedReportMode && !!curActCompleteness.partnersNotCompleted
    const isShowCurTarCompletenessField =
      !!props.composedReportMode && !!curTarCompleteness.partnersNotCompleted

    const editorRender = (type: 'actuals' | 'targets' | 'quota', fy: number, isPrev: boolean) => {
      const isActuals = type === 'actuals'
      const isTarget = type === 'targets'

      const actualsValue = isPrev ? preActual : curActual
      const value = isActuals ? actualsValue : curTarget

      const preState = isActuals ? preActualState : preTargetState
      const curState = isActuals ? curActualState : curTargetState
      const sobState = isPrev ? preState : curState
      const isCellHighlighted = sobState === FIELD_STATE_HIGHLIGHT && !(value || 0)
      const isInputDisabled = sobState === FIELD_STATE_DISABLED

      return (
        <>
          <MandatoryField value={(value || 0).toFixed(1)} isShow={isShowMandatory && isTarget} />
          <FloatingNumberInput
            floatLength={5}
            disabled={isInputDisabled}
            hasSpin={false}
            align="right"
            classes={{
              inputClasses: {
                root: cn({ [styles.highlighted]: isCellHighlighted }),
                content: styles.numberInput,
              },
            }}
            value={(value || 0).toString()}
            onChange={(value) =>
              setValue(idx, value, type, fy, q, isUnits, isOverall, sTotal, isSoB, false)
            }
            checkFn={ValidationHelper.checkPercent}
            maximumFractionDigits={SOB_FRACTION_DIGITS}
          />
        </>
      )
    }

    const onSoBCompletenessClick = (partnersCompleteness: IPartnersCompleteness) => {
      const fullPartnersCompleteness = {
        ...partnersCompleteness,

        fYear: fyear,
        fQuarter: PLANNING_BY_FY_FQ,
        category: cat,
        subCategory: subCat,
        l3Category: l3Cat,
        isActuals: 0,
        isTargets: 1,

        isSob: 1,
      }

      setPartnersCompleteness(fullPartnersCompleteness)
    }

    const completenessTag = props.isShowOnlyCompletedPlans ? 'sobAck' : 'sob'

    const isHidePrevTargets = !props.isShowPrevTargets
    const isHideCurrTargets = isHidePrevTargets && isPrevYear
    const isHideCurrTargetsYoY = isHideCurrTargets || (isNoPlan && !isPrevYear)

    const isShowPrevActualsEditor = isEditFixed && !isPrevYear && isSoBNewLogic

    return (
      <>
        {isShowPrevFY && (
          <td
            className={cn(styles.colSeparator, {
              [styles.colStrip]: !isActiveColumns,
              [styles.rollUp]: isRollUp,
            })}
          >
            <div className={styles.itemWrapper}>
              <div className={styles.itemValues}>
                <div className={styles.itemActual}>
                  {isShowActualsCell && (
                    <>
                      {isShowPreActCompletenessField ? (
                        <PartnersCompletenessField
                          translationTag={completenessTag}
                          partnersCompleteness={preActCompleteness}
                          onClick={onSoBCompletenessClick}
                          type="actuals"
                        />
                      ) : (
                        <>
                          {!isShowPrevActualsEditor
                            ? fieldWrapper(
                                preActual,
                                year - 1,
                                isRetail,
                                marketShareData,
                                'actuals',
                                isShowZero,
                                SOB_FRACTION_DIGITS
                              )
                            : editorRender('actuals', year - 1, true)}
                        </>
                      )}
                    </>
                  )}
                </div>
                <div className={cn(styles.itemTarget, { [styles.itemSoBEdit]: isEditFixed })}>
                  {isShowPreTarCompletenessField ? (
                    <PartnersCompletenessField
                      translationTag={completenessTag}
                      partnersCompleteness={preTarCompleteness}
                      onClick={onSoBCompletenessClick}
                      type="targets"
                    />
                  ) : (
                    <>
                      {isHidePrevTargets ? (
                        <>&nbsp;</>
                      ) : (
                        <>
                          {fieldWrapper(
                            preTarget,
                            year - 1,
                            isRetail,
                            marketShareData,
                            'targets',
                            isShowZero,
                            SOB_FRACTION_DIGITS
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </td>
        )}
        {isShowPrevCalcActuals && (
          <td
            className={cn({
              [styles.colStrip]: !isActiveColumns,
              [styles.colSeparator]: isPlanningByFY,
              [styles.rollUp]: isRollUp,
            })}
          >
            <div className={styles.itemWrapper}>
              <div className={styles.itemValues}>
                <div className={cn(styles.itemActual, styles.itemTarget)}>&nbsp;</div>
                <div
                  className={cn(styles.itemTarget, {
                    [styles.itemSoBEditCell]: isEditFixed && isEditCellsTarget,
                    [styles.itemSoBEdit]:
                      isEditFixed && !isEditCellsTarget && !isEditCellsActualsOnly,
                    [styles.itemSoBEditActuals]: isEditFixed && isEditCellsActualsOnly,
                  })}
                >
                  &nbsp;
                </div>
              </div>
            </div>
          </td>
        )}
        <td
          className={cn({
            [styles.colStrip]: !isActiveColumns,
            [styles.colSeparator]: isPlanningByFY && !isShowPrevCalcActuals,
            [styles.colSeparatorThin]: isPlanningByFY && isShowPrevCalcActuals,
            [styles.rollUp]: isRollUp,
          })}
        >
          <div className={styles.itemWrapper}>
            <div className={styles.itemValues}>
              <div className={cn(styles.itemActual, styles.itemTarget)}>
                {isShowActualsCell && (
                  <>
                    {isShowCurActCompletenessField ? (
                      <PartnersCompletenessField
                        translationTag={completenessTag}
                        partnersCompleteness={curActCompleteness}
                        onClick={onSoBCompletenessClick}
                        type="actuals"
                      />
                    ) : (
                      <>
                        {!isEditCellsActuals
                          ? fieldWrapper(
                              curActual,
                              year,
                              isRetail,
                              marketShareData,
                              'actuals',
                              isShowZero,
                              SOB_FRACTION_DIGITS
                            )
                          : editorRender('actuals', year, false)}
                      </>
                    )}
                  </>
                )}
              </div>
              <div
                className={cn(styles.itemTarget, {
                  [styles.itemSoBEditCell]: isEditFixed && isEditCellsTarget,
                  [styles.itemSoBEdit]:
                    isEditFixed && !isEditCellsTarget && !isEditCellsActualsOnly,
                  [styles.itemSoBEditActuals]: isEditFixed && isEditCellsActualsOnly,
                })}
              >
                {isNoPlan && !isPrevYear ? (
                  <Translation text="jbp-planning-no-plan" span />
                ) : (
                  <>
                    {isShowCurTarCompletenessField ? (
                      <PartnersCompletenessField
                        translationTag={completenessTag}
                        partnersCompleteness={curTarCompleteness}
                        onClick={onSoBCompletenessClick}
                        type="targets"
                      />
                    ) : (
                      <>
                        {!isEditCellsTarget ? (
                          <>
                            {isHideCurrTargets ? (
                              <>&nbsp;</>
                            ) : (
                              <>
                                <MandatoryField
                                  value={(curTarget || 0).toFixed(1)}
                                  isShow={isShowMandatory}
                                />
                                {fieldWrapper(
                                  curTarget,
                                  year,
                                  isRetail,
                                  marketShareData,
                                  'targets',
                                  isShowZero,
                                  SOB_FRACTION_DIGITS
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          editorRender('targets', year, false)
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </td>
        <td className={cn({ [styles.colStrip]: !isActiveColumns, [styles.rollUp]: isRollUp })}>
          <div className={styles.itemWrapper}>
            <div className={cn(styles.itemIcon, { [styles.itemEditIcon]: isEditCellsTarget })}>
              {isShowActualsCell && (
                <>
                  {isShowCurActCompletenessField ? (
                    <>-</>
                  ) : (
                    <>
                      <GrowField
                        percent={yoyActual}
                        fractionDigits={SOB_FRACTION_DIGITS}
                        isPaleColor={true}
                        diff
                      />
                    </>
                  )}
                </>
              )}
              <div className={cn({ [styles.itemSoBEdit]: isEditFixed })}>
                {isHideCurrTargetsYoY ? (
                  <span>&nbsp;</span>
                ) : (
                  <>
                    {isShowCurTarCompletenessField ? (
                      <>-</>
                    ) : (
                      <>
                        <GrowField percent={yoyTarget} fractionDigits={SOB_FRACTION_DIGITS} diff />
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </td>
      </>
    )
  }

  const renderQOverall = (
    idx: number,
    isOverall: boolean,
    year: number,
    q: number,
    isUnits: boolean,
    isEditAllowed: boolean,
    isPrevYear: boolean,
    isNoPlan: boolean,
    isNoSplit: boolean,
    isRollUp: boolean,
    futureYears: number
  ) => {
    const isEditFixed = isEditAllowed && (!isUseContractuals || splitType !== 'Total') && !isRollUp

    const isPlanningByFY = q >= PLANNING_BY_FY_FQ

    const isShowPrevFY = !isPlanningByFY || (isShowPrePreYear && isPrevYear)
    const isShowPrevCalc = isPlanningByFY && isPrevYear
    const isShowPrevCalcActuals = isShowPrevCalc && isShowCalcActuals
    const isUseCalcActualsForYoY = isPlanningByFY && !isPrevYear && isShowCalcActuals

    const sTotal = ''
    const isSoB = false
    const rounding = isUnits ? '' : props.rounding

    const preActuals = getValue(
      idx,
      'actuals',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      false
    )
    const currActuals = getValue(idx, 'actuals', year, q, isUnits, sTotal, isSoB, isNoSplit, false)
    const preQuota = getValue(
      idx,
      'quota',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp
    )
    const currQuota = getValue(idx, 'quota', year, q, isUnits, sTotal, isSoB, isNoSplit, isRollUp)
    const preTargets = getValue(
      idx,
      'targets',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp
    )
    const currTargets = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp
    )
    const comment = getValueFrom(idx, 'targets', year, q, isNoSplit, isRollUp)
    const planState = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      PLAN_STATE_FIELD
    )

    const calActualsFy = isUseCalcActualsForYoY ? year - 1 : year
    const preActualsCalc = getCalcActuals(idx, calActualsFy, isUnits, sTotal, isSoB, isNoSplit)

    const preActualsForYoY = isUseCalcActualsForYoY ? preActualsCalc : preActuals

    const yoyTargets = calcPercentage(preActualsForYoY, currTargets)
    const yoyActuals = calcPercentage(preActualsForYoY, currActuals)
    const yoyQuota = calcPercentage(preActualsForYoY, currQuota)

    const gtmOnline = getGtmPoints(marketShareData, currTargets, year, 'Online')
    const gtmInstore = getGtmPoints(marketShareData, currTargets, year, 'Instore')
    const gtmOnlineFormatted = formatMoneyInteger(gtmOnline)
    const gtmInstoreFormatted = formatMoneyInteger(gtmInstore)

    const isQuarterPlanning =
      !!props.dataSetInfo.IsOnlyQuarterlyPlanning || isOn(currentCat, 'quarter', IS_QUARTER_DEFAULT)
    const isActiveColumns =
      (isQuarterPlanning && !isPlanningByFY) ||
      (!isQuarterPlanning && isPlanningByFY) ||
      !!futureYears

    const setting = props.formats[idx]
    const isCategoryAlwaysOverall = !setting.SubCategory

    const l3Cat = setting.L3Category
    const isL3 = !!l3Cat
    const isL3Collapsed = getIsCollapsedL3Category(targetsItems, fyear, setting.SubCategory)
    const isEditModeForCollapsed = isEditFixed && (isFixedCollapsed || isCategoryAlwaysOverall)
    const isEditModeForL3Collapsed = isEditFixed && isL3Collapsed
    const isEditCells =
      (isL3 ? isEditModeForL3Collapsed : isEditModeForCollapsed) && isActiveColumns && !isPrevYear
    const isEditComment = isEditCells && !isPlanningByFY

    const isActiveRow =
      (isFixedCollapsed && isOverall) ||
      (!isFixedCollapsed && !isOverall) ||
      isCategoryAlwaysOverall

    const flags = partnerInfo?.PartnerFlags || ''
    const isMandatoryByFlag = isSubCategoryMandatory(
      flags,
      setting.MandatoryByFlags,
      sectionSettings,
      false
    )
    const isMandatoryUnitsByFlag = isSubCategoryMandatory(
      flags,
      setting.UnitsMandatoryByFlags,
      sectionSettings,
      false
    )
    const isShowMandatoryByFlag =
      (!isUnits && isMandatoryByFlag.isMandatory) || (isUnits && isMandatoryUnitsByFlag.isMandatory)
    const isShowMandatoryForCategory = isOverall || !isCollapseAllowed
    const isShowMandatoryCommon = isMandatoryByFlagLogic
      ? isShowMandatoryByFlag
      : isShowMandatoryForCategory
    const isShowMandatory = isShowMandatoryCommon && !isPrevYear && !props.composedReportMode

    const isShowZero = !IS_SHOW_NULL && isShowMandatory && Number(currTargets || 0) <= 0

    let isShowNoSplitActuals = true
    if (isNoSplit) {
      const actualsNoSplitSum = getTwoYearsSum({
        formats: props.formats,
        settingsIndex: idx,
        items: actualsNoSplitItems,
        fyear,
        isGetUnits: false,
        isAddContractual: false,

        actualsType,
        isDirect: false,

        isComposedCompletedPlans: props.isShowOnlyCompletedPlans,
        isComposedSob: false,
      })
      isShowNoSplitActuals = !!actualsNoSplitSum
    }

    const isShowActualsCell = (isNoSplit ? isShowNoSplitActuals : props.showActuals) && !isRollUp
    const isShowQuota = props.showQuota && !isRollUp
    const isStripCol = !isActiveColumns && !isRollUp

    const isHidePrevTargets = !props.isShowPrevTargets
    const isHideCurrTargets = isHidePrevTargets && isPrevYear
    const isHideCurrTargetsYoY = isHideCurrTargets || (isNoPlan && !isPrevYear)

    const editorRender = () => {
      const isCellHighlighted = planState === FIELD_STATE_HIGHLIGHT && !(currTargets || 0)
      const isInputDisabled = planState === FIELD_STATE_DISABLED

      return (
        <>
          <MandatoryField value={(currTargets || 0).toFixed(0)} isShow={isShowMandatory} />
          <FloatingNumberInput
            floatLength={5}
            disabled={isInputDisabled}
            hasSpin={false}
            align="right"
            classes={{
              inputClasses: {
                root: cn(styles.cell, styles.cell__input, {
                  [styles.highlighted]: isCellHighlighted,
                }),
                content: styles.numberInput,
              },
            }}
            value={(currTargets || 0).toString()}
            onChange={(value) =>
              setValue(idx, value, 'targets', year, q, isUnits, isOverall, sTotal, isSoB, isNoSplit)
            }
            checkFn={ValidationHelper.checkNumber}
            maximumFractionDigits={0}
          />
        </>
      )
    }

    return (
      <>
        {isShowPrevFY && (
          <td
            className={cn(styles.colSeparator, {
              [styles.colStrip]: isStripCol,
            })}
          >
            <div className={styles.itemWrapper}>
              <div className={styles.itemValues}>
                <div className={styles.itemQuota}>
                  {isShowQuota && (
                    <>
                      {isHidePrevTargets ? (
                        <>&nbsp;</>
                      ) : (
                        <>
                          {fieldWrapper(
                            preQuota,
                            year - 1,
                            isRetail,
                            marketShareData,
                            'quota',
                            false,
                            0,
                            rounding
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                <div className={styles.itemActual}>
                  {isShowActualsCell &&
                    fieldWrapper(
                      preActuals,
                      year - 1,
                      isRetail,
                      marketShareData,
                      'actuals',
                      false,
                      0,
                      rounding
                    )}
                </div>
                <div
                  className={cn(styles.itemTarget, {
                    [styles.targetEdit]: isEditFixed && isActiveRow,
                  })}
                >
                  {isHidePrevTargets ? (
                    <>&nbsp;</>
                  ) : (
                    <>
                      {fieldWrapper(
                        preTargets,
                        year - 1,
                        isRetail,
                        marketShareData,
                        'targets',
                        false,
                        0,
                        rounding
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </td>
        )}
        {isShowPrevCalcActuals && (
          <td
            className={cn({
              [styles.colStrip]: isStripCol,
              [styles.colSeparator]: isPlanningByFY,
            })}
          >
            <div
              className={cn(styles.itemWrapper, {
                [styles.itemOverall]: !(props.showActuals || isShowQuota) && !isEditCells,
              })}
            >
              <div className={styles.itemValues}>
                <div className={styles.itemQuota}>{isShowQuota && <>&nbsp;</>}</div>
                {isShowActualsCell && (
                  <div className={styles.itemActual}>
                    {fieldWrapper(
                      preActualsCalc,
                      year - 1,
                      isRetail,
                      marketShareData,
                      'actuals',
                      false,
                      0,
                      rounding
                    )}
                  </div>
                )}
                <div
                  className={cn(styles.itemTarget, {
                    [styles.targetEdit]: isEditFixed && isActiveRow && !isEditCells,
                  })}
                >
                  {isHideCurrTargets ? (
                    <>&nbsp;</>
                  ) : (
                    <>
                      {isNoPlan && !isPrevYear ? (
                        <Translation text="jbp-planning-no-plan" span />
                      ) : (
                        <>
                          <MandatoryField
                            value={(currTargets || 0).toFixed(0)}
                            isShow={isShowMandatory}
                          />
                          {fieldWrapper(
                            currTargets,
                            year,
                            isRetail,
                            marketShareData,
                            'targets',
                            isShowZero,
                            0,
                            rounding
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </td>
        )}
        <td
          className={cn({
            [styles.colStrip]: isStripCol,
            [styles.colSeparator]: isPlanningByFY && !isShowPrevCalcActuals,
            [styles.colSeparatorThin]: isPlanningByFY && isShowPrevCalcActuals,
          })}
        >
          <div
            className={cn(styles.itemWrapper, {
              [styles.itemOverall]: !(props.showActuals || isShowQuota) && !isEditCells,
            })}
          >
            <div className={styles.itemValues}>
              <div className={styles.itemQuota}>
                {isShowQuota && (
                  <>
                    {isHideCurrTargets ? (
                      <span>&nbsp;</span>
                    ) : (
                      <>
                        {fieldWrapper(
                          currQuota,
                          year,
                          isRetail,
                          marketShareData,
                          'quota',
                          false,
                          0,
                          rounding
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
              <div className={styles.itemActual}>
                {isShowActualsCell &&
                  fieldWrapper(
                    currActuals,
                    year,
                    isRetail,
                    marketShareData,
                    'actuals',
                    false,
                    0,
                    rounding
                  )}
              </div>
              <div
                className={cn(styles.itemTarget, {
                  [styles.targetEdit]: isEditFixed && isActiveRow && !isEditCells,
                })}
              >
                {!isEditCells && <CommentIcon tooltipText={comment} />}
                {!isEditCells ? (
                  <>
                    {isHideCurrTargets ? (
                      <>&nbsp;</>
                    ) : (
                      <>
                        {isNoPlan && !isPrevYear ? (
                          <Translation text="jbp-planning-no-plan" span />
                        ) : (
                          <>
                            <MandatoryField
                              value={(currTargets || 0).toFixed(0)}
                              isShow={isShowMandatory}
                            />
                            {fieldWrapper(
                              currTargets,
                              year,
                              isRetail,
                              marketShareData,
                              'targets',
                              isShowZero,
                              0,
                              rounding
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {isNoPlan && !isPrevYear ? (
                      <div className={styles.noPlanEditField}>
                        <Translation text="jbp-planning-no-plan" span />
                      </div>
                    ) : (
                      <>
                        {!isRetail ? (
                          editorRender()
                        ) : (
                          <Tooltip
                            tipContent={() => (
                              <span className={styles.tipContent}>
                                <span className={styles.tipLine}>
                                  <Translation text="jbp-gtm-priorities-online-tip" span />
                                  {gtmOnlineFormatted}
                                </span>
                                <br />
                                <span className={styles.tipLine}>
                                  <Translation text="jbp-gtm-priorities-instore-tip" span />
                                  {gtmInstoreFormatted}
                                </span>
                              </span>
                            )}
                          >
                            {editorRender()}
                          </Tooltip>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </td>
        <td
          className={cn({
            [styles.colStrip]: isStripCol,
          })}
        >
          <div className={styles.itemWrapper}>
            <div className={cn(styles.itemIcon, { [styles.itemEditIcon]: isEditCells })}>
              {isShowQuota && (
                <>
                  {isHideCurrTargetsYoY ? (
                    <span>&nbsp;</span>
                  ) : (
                    <GrowField
                      percent={yoyQuota}
                      isPaleColor={true}
                      isEmpty={IS_HIDE_QUOTA_GROW}
                      fractionDigits={PERCENT_FRACTION_DIGITS}
                    />
                  )}
                </>
              )}
              {isShowActualsCell && (
                <>
                  {isNoSplit ? (
                    <div>-</div>
                  ) : (
                    <GrowField
                      percent={yoyActuals}
                      isPaleColor={true}
                      fractionDigits={PERCENT_FRACTION_DIGITS}
                    />
                  )}
                </>
              )}
              {isNoSplit ? (
                <>-</>
              ) : (
                <div
                  className={cn({
                    [styles.itemInsteadCommentIcon]: isEditFixed && isActiveRow && !isEditComment,
                  })}
                >
                  {isHideCurrTargetsYoY ? (
                    <span>&nbsp;</span>
                  ) : (
                    <GrowField percent={yoyTargets} fractionDigits={PERCENT_FRACTION_DIGITS} />
                  )}
                </div>
              )}
              {isEditComment && (
                <CommentEditorIcon
                  comment={comment}
                  onClick={() => setCommentEditor({ index: idx, year, q, comment })}
                  isTranslationMode={isTranslationMode}
                />
              )}
            </div>
          </div>
        </td>
      </>
    )
  }

  const renderApplySection = () => {
    const isApplyDisabled =
      !isDataChanged ||
      isNotChanged ||
      validationStatus !== ValidationStatus.Valid ||
      !isTransactionalValid()

    return (
      <table className={cn(stylesTable.table, stylesCompensation.table, styles.table)}>
        <caption className={styles.footer}>
          <ApplyButton
            text={isFixedCollapsed ? 'jbp-hr-save-overall' : 'jbp-hr-save-details'}
            className={styles.footer__apply}
            disabled={isApplyDisabled}
            onClick={applyChangesHandler}
          />
          <Button
            disabled={!isDataChanged || isNotChanged || validationStatus !== ValidationStatus.Valid}
            onClick={discardChanges}
            color={'grey'}
            className={styles.button}
          >
            <Translation text="jbp-cancel" span />
          </Button>
        </caption>
      </table>
    )
  }

  /** -------------------- Effects ----------------------- */

  useEffect(() => {
    if (!props.urlActualsValueType) return

    const urlTypeLower = props.urlActualsValueType.toLowerCase()
    const urlType = Object.values(ActualsValueTypes).find((v) => v.toLowerCase() === urlTypeLower)
    if (!urlType || !actualsTypes.includes(urlType)) return

    onChangeActualsType(urlType)
  }, [props.urlActualsValueType, actualsTypes, onChangeActualsType])

  useEffect(() => {
    if (partnerInfo) {
      calcCollapseMode()
    }
  }, [partnerInfo, calcCollapseMode])

  useEffect(() => {
    updatePendingData(undefined, ValidationStatus.Valid)

    if (
      (partnerId && fyear && buttonCurrType) ||
      props.composedReportMode ||
      props.isQuarterlyBusinessReviewMode
    ) {
      preparePlanningData()
    }
  }, [
    partnerId,
    fyear,
    buttonCurrType,
    props.composedReportMode,
    props.isQuarterlyBusinessReviewMode,
    preparePlanningData,
  ])

  useEffect(() => {
    if (!isCollapsed) {
      props.setIsShowComposedSoB(false)
    }
  }, [isCollapsed, props.setIsShowComposedSoB])

  /** -------------------- Render ----------------------- */

  return (
    <div className={styles.root}>
      <Controller
        onValidationStatusChange={({ status }) => {
          status !== 'WIP' && setValidationStatus(status)
          updatePendingData(undefined, status)
        }}
      >
        {isShowPlanningSection && (
          <table className={cn(stylesTable.table, stylesCompensation.table, styles.table)}>
            <caption>
              <WidgetHeaderWithHelpButton section={HelpSection.FinancialAndSOB}>
                {categoryHeaderKey}
              </WidgetHeaderWithHelpButton>
              <LoaderOverlay show={isApplyingChanges || !isDataLoaded} />
              {isEditAllowed && (
                <tr>
                  <th colSpan={planningColSpan}>
                    <div className={styles.switchersContainer}>
                      {isShowNotApplicableWidget && (
                        <NotApplicableWidget
                          value={isCategoryNA}
                          className={styles.input}
                          canEdit={isNotApplicableAllowed && isEditAllowed}
                          onChange={async () => {
                            if (isNeedToShowSignNADialog) {
                              setIsShowSignDialogNA(true)
                            } else {
                              if (isCategoryNA) {
                                await onChangeNotApplicable()
                              } else {
                                setIsShowConfirmNotApplicableDialog(true)
                              }
                            }
                          }}
                        />
                      )}
                      {(!isNotApplicableAllowed || !isCategoryNA) && (
                        <>
                          <div className={styles.switcher}>
                            <Switch
                              padding
                              disabled={!!props.dataSetInfo.IsOnlyQuarterlyPlanning}
                              checked={
                                !!props.dataSetInfo.IsOnlyQuarterlyPlanning ||
                                isOn(currentCat, 'quarter', IS_QUARTER_DEFAULT)
                              }
                              onChange={() => setSetting(currentCat, 'quarter')}
                            />
                            <div className={styles.switcherText}>
                              <Translation span text="jbp-planning-quarter-switcher" />
                            </div>
                          </div>
                          {!!props.dataSetInfo.IsSoBAvailable && !IS_ALWAYS_SHOW_SOB && (
                            <div className={styles.switcher}>
                              <Switch
                                padding
                                checked={isOn(currentCat, 'sob', IS_ALWAYS_SHOW_SOB)}
                                onChange={() => setSetting(currentCat, 'sob')}
                              />
                              <div className={styles.switcherText}>
                                <Translation span text="jbp-planning-sob-switcher" />
                              </div>
                            </div>
                          )}
                          {!!props.dataSetInfo.IsUnitsAvailable && (
                            <div className={styles.switcher}>
                              <Switch
                                padding
                                disabled={isUnitsMandatory}
                                checked={isOn(currentCat, 'units')}
                                onChange={() => setSetting(currentCat, 'units')}
                              />
                              <div className={styles.switcherText}>
                                <Translation span text="jbp-planning-units-switcher" />
                              </div>
                            </div>
                          )}
                          {!!props.dataSetInfo.IsSoBAvailable && (
                            <div className={styles.switcher}>
                              <Switch
                                padding
                                checked={isOn(currentCat, 'sob-details')}
                                onChange={() => setSetting(currentCat, 'sob-details')}
                              />
                              <div className={styles.switcherText}>
                                <Translation span text="jbp-planning-sob-details-switcher" />
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </th>
                </tr>
              )}

              {isShowNotApplicableMessage && (
                <tr>
                  <th colSpan={planningColSpan}>
                    <div className={styles.input}>
                      <Translation span text="jbp-not-applicable-status-not-applicable" />
                    </div>
                  </th>
                </tr>
              )}

              {!isCategoryNA && (
                <tr>
                  <th colSpan={planningColSpan}>
                    <div className={styles.switchersContainer}>
                      {isShowCurrencyCtrl && (
                        <>
                          <CurrenciesButtons />
                          {isShowNetNdpCtrl && <div className={styles.filterNextItemEmpty} />}
                        </>
                      )}
                      {isShowNetNdpCtrl && (
                        <>
                          <ActualsTypeButtons />
                          {isShowSalesTypeCtrl && <div className={styles.filterNextItemEmpty} />}
                        </>
                      )}
                      {isShowSalesTypeCtrl && (
                        <>
                          <SellTypeButtons actualsType={actualsType} />
                          <div className={styles.filterNextItemEmpty} />
                        </>
                      )}
                      {isShowActualsCtrl && !IS_ALWAYS_SHOW_ACTUALS && (
                        <div
                          className={cn(styles.filterItem, {
                            [styles.filterNextItem]: !isShowActualsCtrlFirst,
                          })}
                          style={{ color: actualsColor }}
                        >
                          <Checkbox
                            checked={props.showActuals}
                            label={<Translation text={'jbp-partner-actuals-show-actuals'} span />}
                            onChange={(val) => props.setShowActuals(!!val)}
                          />
                        </div>
                      )}
                      {isShowQuotaCtrl && (
                        <div className={styles.filterItem} style={{ color: quotaColor }}>
                          <Checkbox
                            checked={props.showQuota}
                            label={<Translation text={'jbp-partner-actuals-show-quota'} span />}
                            onChange={(val) => props.setShowQuota(!!val)}
                          />
                        </div>
                      )}
                      {isDistributor && isRegionalDistributor && (
                        <Checkbox
                          className={cn(styles.filterItem, {
                            [styles.filterNextItem]: !isShowDistributorCtrlFirst,
                          })}
                          checked={props.isRegionalPlanning}
                          label={
                            <Translation text={'jbp-distributor-show-regional-planning'} span />
                          }
                          onChange={(val) => props.setIsRegionalPlanning(!!val)}
                        />
                      )}
                      {isShowComposedModeSwitchers && (
                        <>
                          <div className={styles.switcher}>
                            <Switch
                              padding
                              disabled={props.isShowComposedSoB}
                              checked={props.isShowOnlyCompletedPlans}
                              onChange={() =>
                                props.setIsShowOnlyCompletedPlans(
                                  !props.isShowOnlyCompletedPlans,
                                  true
                                )
                              }
                            />
                            <div className={styles.switcherText}>
                              <Translation span text="jbp-planning-show-only-completed-plans" />
                            </div>
                          </div>
                          {!!props.dataSetInfo.IsSoBAvailable && (
                            <div className={styles.switcher}>
                              <Switch
                                padding
                                disabled={isComposedSobDisabled}
                                checked={props.isShowComposedSoB}
                                onChange={toggleShowComposedSob}
                              />
                              <div className={styles.switcherText}>
                                <Translation span text="jbp-planning-show-sob" />
                              </div>
                            </div>
                          )}
                        </>
                      )}
                      {isShowPrevTargetsCtrl && (
                        <div className={styles.filterItem}>
                          <Checkbox
                            checked={props.isShowPrevTargets}
                            onChange={() => props.setIsShowPrevTargets(!props.isShowPrevTargets)}
                            label={
                              <Translation
                                span
                                text={`jbp-planning-show-prev-targets${
                                  props.showQuota ? '-quota' : ''
                                }`}
                                replaceParams={showPrevTargetsParams}
                              />
                            }
                          />
                        </div>
                      )}
                      {isShowComposedModeSwitchers &&
                        IS_USE_RECALC_PLANS_FROM_BOTTOM_FUNCTIONALITY && (
                          <div className={styles.switcher}>
                            <Switch
                              padding
                              checked={isRecalcPlans}
                              onChange={() => setIsRecalcPlans((val) => !val)}
                            />
                            <div className={styles.switcherText}>
                              <Translation span text="jbp-planning-recalc-plans-from-bottom" />
                            </div>
                          </div>
                        )}
                      {isShowAllSplitsCtrl && (
                        <div className={styles.filterItem}>
                          <Checkbox
                            checked={isShowAllSplits}
                            onChange={() => setIsShowAllSplits((val) => !val)}
                            label={
                              <Translation text={'jbp-planning-show-contr-trans-switcher'} span />
                            }
                          />
                        </div>
                      )}
                    </div>
                  </th>
                </tr>
              )}
            </caption>

            {!isCategoryNA && (
              <thead>
                {isShowInformationBanners && (
                  <tr>
                    <th colSpan={planningColSpan}>
                      {props.showActuals && (
                        <div className={styles.infoContainer}>
                          <i
                            className={cn('kbase kbase-info-alt', styles.infoIcon)}
                            aria-hidden="true"
                          />
                          <span className={styles.actualsLegend}>
                            <Translation text="jbp-planning-actuals-legend" actionsInside />
                          </span>
                          <span className={styles.targetsLegend}>
                            <Translation text="jbp-planning-targets-legend" actionsInside />
                          </span>
                        </div>
                      )}
                      <div className={styles.infoContainer}>
                        {!props.showActuals && (
                          <i
                            className={cn('kbase kbase-info-alt', styles.infoIcon)}
                            aria-hidden="true"
                          />
                        )}
                        <Translation
                          text={
                            props.showActuals
                              ? 'jbp-planning-targets-info'
                              : 'jbp-planning-actuals-info'
                          }
                          actionsInside
                        />
                      </div>
                      <div className={styles.infoContainer}>
                        <MandatoryField value={null} isShow={true} />
                        <Translation text="jbp-planning-mandatory-legend" />
                      </div>
                    </th>
                  </tr>
                )}
                {isUseContractuals && (
                  <tr className={styles.splitPlanningRow}>
                    <th colSpan={planningColSpan}>
                      <SplitPlanningSwitcher splitType={splitType} setSplitType={setSplitType} />
                    </th>
                  </tr>
                )}
                {!isCategoryNA && (
                  <>
                    {isShowMapRow && (
                      <MapRowStandard
                        mapData={props.mapData}
                        fyear={fyear}
                        currentCat={currentCat}
                        tag="jbp-market-growth-guidance"
                        isShowCalcActuals={isShowCalcActuals}
                        isComposedReport={!!props.composedReportMode}
                        isShowFutureYears={isShowFutureYears}
                        hideIfEmpty
                      />
                    )}
                    <CategoryHeaderStandard
                      translationKey="jbp-planning-header"
                      fyear={fyear}
                      isShowCalcActuals={isShowCalcActuals}
                      isShowFutureYears={isShowFutureYears}
                      currentFQuarter={jbpSettings.currentFQuarter}
                      isComposedReport={!!props.composedReportMode}
                      periodFQuarters={fQuarters}
                      isQbrYtd={props.isQuarterlyBusinessReviewMode}
                    />
                  </>
                )}
              </thead>
            )}
            {!isCategoryNA && isShowCurrencyBlock && (
              <tbody>
                {props.formats.map((format, idx) => {
                  const cat = format.Category
                  const subCat = format.SubCategory

                  const isOverall = subCat === OVERALL_CATEGORY || !subCat
                  const isShowCollapseButton =
                    (isEditAllowed || props.composedReportMode) &&
                    isCollapseAllowed &&
                    !isOverallOnly &&
                    isOverall

                  const l3Cat = format.L3Category
                  const isL3Overall = l3Cat === OVERALL_CATEGORY
                  const isL3 = !!l3Cat

                  const isIsCatExpanded = getIsExpandedByFlags({
                    settings: format.Settings,
                    flagsState: props.partnerFlagsState,
                  })

                  const isL3Collapsed =
                    getIsCollapsedL3Category(targetsItems, fyear, subCat) && !isIsCatExpanded
                  const isShowL3CollapseButton =
                    (isEditAllowed || props.composedReportMode) &&
                    isL3 &&
                    isL3Overall &&
                    !isIsCatExpanded
                  const isShowL3Border = isL3 && (!isL3Overall || (isL3Overall && !isL3Collapsed))
                  const isL3SubCat = isL3 && !isL3Overall
                  const l3Idx = getL3Index(format)

                  const flags = partnerInfo?.PartnerFlags || ''

                  // Is row NoPlan
                  const fyFq = PLANNING_BY_FY_FQ
                  const isNoPlan = getIsNoPlan(targetsItems, props.formats, idx, fyear, fyFq, false)
                  const isNoPlanCon = getIsNoPlan(
                    targetsItems,
                    props.formats,
                    idx,
                    fyear,
                    fyFq,
                    true
                  )
                  const withPlanCount = getSubCategoriesWithPlanCount(
                    targetsItems,
                    props.formats,
                    idx,
                    fyear,
                    fyFq,
                    false,
                    isMandatoryByFlagLogic,
                    flags,
                    sectionSettings
                  )
                  const withPlanCountCon = getSubCategoriesWithPlanCount(
                    targetsItems,
                    props.formats,
                    idx,
                    fyear,
                    fyFq,
                    true,
                    isMandatoryByFlagLogic,
                    flags,
                    sectionSettings
                  )
                  const isLastWithPlan = !isNoPlan && withPlanCount <= 1
                  const isLastWithPlanCon = !isNoPlanCon && withPlanCountCon <= 1

                  // Mandatory - is Show
                  // (the same for contractual logic)
                  const isMandatoryByFlag = isSubCategoryMandatory(
                    flags,
                    format.MandatoryByFlags,
                    sectionSettings,
                    true
                  )
                  const isShowMandatoryForCategory = isOverall || !isCollapseAllowed
                  const isShowMandatoryCommon = isMandatoryByFlagLogic
                    ? isMandatoryByFlag.isMandatory
                    : isShowMandatoryForCategory
                  const isShowMandatory = isShowMandatoryCommon && !props.composedReportMode

                  // Calc Mandatory Count only on Current Level L2 or L3
                  // (the same for contractual logic?)
                  const mandatoryInCatCount = getMandatoryLinesInCategoryCount({
                    partnerFlags: flags,
                    formats: props.formats,
                    currentFormat: format,
                    sectionSettings,
                    isUnits: false,
                    restrictL3Child: '',
                  })

                  // Is Show NoPlan
                  const isShowNoPlanCommon =
                    isShowMandatory &&
                    isEditAllowed &&
                    isEditFixed &&
                    (!isMandatoryByFlagLogic || mandatoryInCatCount > 1) &&
                    !isIsCatExpanded &&
                    !isOverall
                  const isShowNoPlan = isShowNoPlanCommon && !isCollapseAllowed
                  const isShowNoPlanCon = isShowNoPlanCommon

                  // Is Disable NoPlan
                  const isNoPlanDisabled = (isL3Overall && !isL3Collapsed) || isLastWithPlan
                  const isNotActiveRows =
                    (isL3Overall && !isL3Collapsed) || (isOverall && !isFixedCollapsed)
                  const isNoPlanDisabledCon = (isNotActiveRows && !isOverall) || isLastWithPlanCon

                  const uniqueCategory = isOverall ? cat : subCat
                  const uniqueKey = `jbp-planning-contractual-${uniqueCategory}`

                  const isEditRow = isEditAllowed && (!isOverall || isFixedCollapsed)

                  const isShowPartnersCompletenessForCategory =
                    IS_SHOW_PARTNERS_COMPLETENESS_FOR_SUB_CATEGORIES || isOverall

                  const isShowPartnersCompleteness =
                    !!props.composedReportMode &&
                    isShowPartnersCompletenessForCategory &&
                    (IS_SHOW_PARTNERS_COMPLETENESS_FOR_ALL_ROWS ||
                      (!props.isShowOnlyCompletedPlans &&
                        ((!isL3Overall && !isOverall) ||
                          (isL3Overall && isL3Collapsed) ||
                          (isOverall && isFixedCollapsed))))
                  const isShowPartnersCompletenessForContractualPlan =
                    isShowPartnersCompleteness && IS_SHOW_PARTNERS_COMPLETENESS_FOR_CONTRACTUAL_PLAN
                  const isAdjustPartnersCompleteness = isOverall || isL3Overall

                  const isEmptyRow = !getRowSum(idx, false)
                  const isHideRow =
                    (isFixedCollapsed && !isOverall) ||
                    (isL3Collapsed && !isL3Overall) ||
                    (isEmptyRow &&
                      !isOverall &&
                      !isEditMode &&
                      !props.composedReportMode &&
                      !props.isQuarterlyBusinessReviewMode)

                  if (isHideRow) {
                    return <Fragment key={`jbp-target-actuals-${subCat}-${idx}-hided`}></Fragment>
                  }

                  const isShowGlobalSoB =
                    !!partnerInfo?.IsGlobal && !!props.globalCategory?.IsSoBAvailable

                  const isShowSoB =
                    isShowGlobalSoB ||
                    (!partnerInfo?.IsGlobal &&
                      !isHideSoB &&
                      (isOverall || !props.composedReportMode) &&
                      (!props.composedReportMode || props.isShowComposedSoB) &&
                      (isOverall || isOn(currentCat, 'sob-details')) &&
                      ((!IS_ALWAYS_SHOW_SOB && isOn(currentCat, 'sob', IS_ALWAYS_SHOW_SOB)) ||
                        (IS_ALWAYS_SHOW_SOB && !!format.IsSoBAvailable)) &&
                      isNoSplitPlans)

                  const isEditSoB = isEditAllowed && isShowSoB

                  const completenessItem = getCompletenessItem({
                    formats: props.formats,
                    settingsIndex: idx,
                    items: targetsItems,
                    fy: fyear,
                    isSoB: false,
                  })
                  const completenessAckTag = props.isShowOnlyCompletedPlans ? 'ack' : 'all'
                  const completenessTag = isShowSoB ? 'ful' : completenessAckTag

                  const isShowNoSplit =
                    !!props.composedReportMode &&
                    ((isOverall && !isFixedCollapsed) || (isL3Overall && !isL3Collapsed))

                  const onPartnersCompletenessClick = (
                    partnersCompleteness: IPartnersCompleteness
                  ) => {
                    const fullPartnersCompleteness: IPartnersCompleteness = {
                      ...partnersCompleteness,

                      fYear: fyear,
                      fQuarter: PLANNING_BY_FY_FQ,
                      category: cat,
                      subCategory: subCat,
                      l3Category: l3Cat,
                      isActuals: 0,
                      isTargets: 1,
                      isSob: 0,

                      isAcknowledged: props.isShowOnlyCompletedPlans ? 1 : 0,
                      isCompleted: isShowSoB ? 1 : 0,
                    }

                    setPartnersCompleteness(fullPartnersCompleteness)
                  }

                  const sType = splitType === 'Contractual' ? 'c' : 't'

                  // Old clause for Global: !!partnerInfo?.IsGlobal && !isOverall
                  const isHideCategoryToolTip = false

                  return (
                    <Fragment key={`jbp-target-actuals-${subCat}-${idx}`}>
                      <tr
                        key={`jbp-target-actuals-${subCat}-${idx}`}
                        className={cn({ [styles.contractualTotalRow]: isUseContractuals })}
                      >
                        <td
                          className={cn(
                            styles.totalCell,
                            { [styles.catTitle]: !isEditRow },
                            { [styles.catTitleEdit]: isEditRow },
                            { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                            { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                            { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                            { [styles.catL3p]: isL3 },
                            { [styles.catL2]: !isOverall && !isL3 },
                            { [styles.catL3]: isL3SubCat && !isEditAllowed },
                            { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                          )}
                        >
                          {isShowCollapseButton && (
                            <div className={styles.categoryTitle}>
                              <span
                                className={styles.icon_expanded}
                                onClick={toggleIsCollapseCategory}
                              >
                                <i
                                  className={cn('kbase', {
                                    'kbase-compress': !isFixedCollapsed,
                                    'kbase-expand': isFixedCollapsed,
                                  })}
                                  style={{ marginRight: '8px' }}
                                  aria-hidden="true"
                                />
                                <CategoryTitle
                                  category={cat}
                                  subCategory={subCat}
                                  l3Category={l3Cat}
                                  tip={format.PopupComment}
                                  tipPrefix={globalCategoryTipPrefix}
                                  isHideTooltip={isHideCategoryToolTip}
                                />
                              </span>
                              <CategorySubTitleStandard
                                isShowSubTitles={isOverall && !props.composedReportMode}
                                isShowQuotas={props.showQuota}
                                isShowActuals={props.showActuals}
                                isEditRow={isEditRow}
                              />
                            </div>
                          )}
                          {isShowL3CollapseButton && (
                            <span
                              className={styles.icon_expanded}
                              onClick={() => {
                                setIsL3Collapsed(idx, !isL3Collapsed, fyear)
                              }}
                            >
                              <i
                                className={cn('kbase', {
                                  'kbase-compress': !isL3Collapsed,
                                  'kbase-expand': isL3Collapsed,
                                })}
                                style={{ marginRight: '8px' }}
                                aria-hidden="true"
                              ></i>
                              <CategoryTitle
                                category={cat}
                                subCategory={subCat}
                                l3Category={l3Cat}
                                endContent={<></>}
                                tip={format.PopupComment}
                                tipPrefix={globalCategoryTipPrefix}
                                isHideTooltip={isHideCategoryToolTip}
                              />
                            </span>
                          )}
                          {isL3 && !isL3Overall && IS_USE_LEVEL_ICON && (
                            <span className={styles.l3icon}>
                              <i
                                className={'kbase kbase-arrow-right'}
                                style={{ color: '#2c3038', fontWeight: 'bold' }}
                              />
                            </span>
                          )}
                          {!isShowCollapseButton && !isShowL3CollapseButton && (
                            <div className={styles.categoryTitle}>
                              <CategoryTitle
                                category={cat}
                                subCategory={subCat}
                                l3Category={l3Cat}
                                tip={format.PopupComment}
                                tipPrefix={globalCategoryTipPrefix}
                                isHideTooltip={isHideCategoryToolTip}
                              />
                              <CategorySubTitleStandard
                                isShowSubTitles={isOverall && !props.composedReportMode}
                                isShowQuotas={props.showQuota}
                                isShowActuals={props.showActuals}
                                isEditRow={isEditRow}
                              />
                            </div>
                          )}
                          {isNoSplitPlans && isShowNoPlan && (
                            <>
                              <br />
                              <div
                                className={cn(
                                  styles.infoContainer,
                                  styles.infoContainerWithCheckbox
                                )}
                              >
                                <div className={styles.noPlanSwitcher}>
                                  <Checkbox
                                    padding
                                    disabled={isNoPlanDisabled}
                                    checked={isNoPlan}
                                    onChange={() => {
                                      setIsNoPlan(idx, !isNoPlan, fyear, isOverall, '')
                                    }}
                                  />
                                  <div
                                    className={cn(styles.noPlanSwitcherText, {
                                      [styles.disabledItem]: isNoPlanDisabled,
                                    })}
                                  >
                                    <Translation span text="jbp-planning-no-plan-switcher" />
                                  </div>
                                </div>
                                {!isNoPlan && withPlanCount <= 1 && (
                                  <HintComponent text="jbp-planning-no-plan-warning" />
                                )}
                              </div>
                            </>
                          )}
                          {!isNoSplitPlans && isShowNoPlanCon && sType !== 't' && (
                            <>
                              <br />
                              <div className={cn(styles.noPlanSwitcher, styles.noPlanContractual)}>
                                <Checkbox
                                  padding
                                  disabled={isNoPlanDisabledCon}
                                  checked={isNoPlanCon}
                                  onChange={() => {
                                    setIsNoPlan(idx, !isNoPlanCon, fyear, isOverall, sType)
                                  }}
                                />
                                <div
                                  className={cn(styles.noPlanSwitcherText, {
                                    [styles.disabledItem]: isNoPlanDisabledCon,
                                  })}
                                >
                                  <Translation span text="jbp-planning-no-plan-switcher" />
                                </div>
                              </div>
                            </>
                          )}
                          {isShowPartnersCompleteness && (
                            <div
                              className={cn(styles.partnersCompleteness, {
                                [styles.partnersCompletenessAdjust]: isAdjustPartnersCompleteness,
                              })}
                            >
                              <br />
                              <PartnersCompletenessField
                                translationTag={completenessTag}
                                partnersCompleteness={completenessItem}
                                onClick={onPartnersCompletenessClick}
                              />
                            </div>
                          )}
                        </td>
                        {isNoSplitPlans
                          ? renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              -fyFq,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false,
                              false
                            )
                          : renderQContr(
                              idx,
                              isOverall,
                              -fyFq,
                              isEditAllowed,
                              false,
                              sType,
                              isNoPlanCon
                            )}
                        {isNoSplitPlans
                          ? renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false,
                              false
                            )
                          : renderQContr(
                              idx,
                              isOverall,
                              fyFq,
                              isEditAllowed,
                              false,
                              sType,
                              isNoPlanCon
                            )}
                        {fQuarters.map((q) =>
                          isNoSplitPlans
                            ? renderQ(
                                idx,
                                isOverall,
                                isL3Overall,
                                q,
                                isEditAllowed,
                                false,
                                isNoPlan,
                                false,
                                false
                              )
                            : renderQContr(
                                idx,
                                isOverall,
                                q,
                                isEditAllowed,
                                false,
                                sType,
                                isNoPlanCon
                              )
                        )}
                        {isShowFutureYears &&
                          (isNoSplitPlans
                            ? renderQ(
                                idx,
                                isOverall,
                                isL3Overall,
                                fyFq + 1,
                                isEditAllowed,
                                false,
                                isNoPlan,
                                false,
                                false
                              )
                            : renderQContr(
                                idx,
                                isOverall,
                                fyFq + 1,
                                isEditAllowed,
                                false,
                                sType,
                                isNoPlanCon
                              ))}
                        {isShowFutureYears &&
                          (isNoSplitPlans
                            ? renderQ(
                                idx,
                                isOverall,
                                isL3Overall,
                                fyFq + 2,
                                isEditAllowed,
                                false,
                                isNoPlan,
                                false,
                                false
                              )
                            : renderQContr(
                                idx,
                                isOverall,
                                fyFq + 2,
                                isEditAllowed,
                                false,
                                sType,
                                isNoPlanCon
                              ))}
                      </tr>

                      {isShowNoSplit && (
                        <tr
                          key={`jbp-target-split-${subCat}-${idx}`}
                          className={cn({ [styles.contractualTotalRow]: isUseContractuals })}
                        >
                          <td
                            className={cn(
                              styles.totalCell,
                              { [styles.catTitle]: !isEditRow },
                              { [styles.catTitleEdit]: isEditRow },
                              { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                              { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                              { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                              { [styles.catL3p]: isL3 },
                              {
                                [styles.catL2]:
                                  (!isOverall && !isL3) || (isShowNoSplit && isOverall),
                              },
                              {
                                [styles.catL3]:
                                  (isL3SubCat && !isEditAllowed) || (isShowNoSplit && isL3Overall),
                              },
                              { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                            )}
                          >
                            <Translation text="jbp-planning-composed-no-split" span actionsInside />
                          </td>
                          {renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            true,
                            false
                          )}
                          {renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            true,
                            false
                          )}
                          {fQuarters.map((q) =>
                            renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              q,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              true,
                              false
                            )
                          )}
                          {isShowFutureYears &&
                            renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq + 1,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              true,
                              false
                            )}
                          {isShowFutureYears &&
                            renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq + 2,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              true,
                              false
                            )}
                        </tr>
                      )}

                      {!!partnerInfo?.IsGlobal && (
                        <tr
                          key={`jbp-target-rollup-${subCat}-${idx}`}
                          className={cn(styles.contractualRow, styles.rollupRow)}
                        >
                          <td
                            className={cn(
                              { [styles.catTitle]: !isEditRow },
                              { [styles.catTitleEdit]: isEditRow },
                              { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                              { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                              { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                              { [styles.catL3p]: isL3 },
                              {
                                [styles.catL2]:
                                  (!isOverall && !isL3) || (isShowNoSplit && isOverall),
                              },
                              {
                                [styles.catL3]:
                                  (isL3SubCat && !isEditAllowed) || (isShowNoSplit && isL3Overall),
                              },
                              { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                            )}
                          >
                            <Translation text="jbp-planning-rollup" span actionsInside />
                          </td>
                          {renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            false,
                            true
                          )}
                          {renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            false,
                            true
                          )}
                          {fQuarters.map((q) =>
                            renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              q,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false,
                              true
                            )
                          )}
                          {isShowFutureYears &&
                            renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq + 1,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false,
                              true
                            )}
                          {isShowFutureYears &&
                            renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq + 2,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false,
                              true
                            )}
                        </tr>
                      )}

                      {isUseContractuals && (
                        <>
                          {isShowContrTrans && (
                            <tr key={`${uniqueKey}-${idx}`} className={styles.contractualRow}>
                              <td
                                className={cn(
                                  { [styles.catTitle]: !isEditRow },
                                  { [styles.catTitleEdit]: isEditRow },
                                  { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                                  { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                                  { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                                  { [styles.catL3p]: isL3 },
                                  { [styles.catL2]: !isOverall && !isL3 },
                                  { [styles.catL3]: isL3SubCat && !isEditAllowed },
                                  { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                                )}
                              >
                                <Translation span text="jbp-planning-contractual-contractual" />
                                {isShowNoPlanCon && (
                                  <>
                                    <br />
                                    <div
                                      className={cn(
                                        styles.noPlanSwitcher,
                                        styles.noPlanContractual
                                      )}
                                    >
                                      <Checkbox
                                        padding
                                        disabled={isNoPlanDisabledCon}
                                        checked={isNoPlanCon}
                                        onChange={() => {
                                          setIsNoPlan(idx, !isNoPlanCon, fyear, isOverall, sType)
                                        }}
                                      />
                                      <div
                                        className={cn(styles.noPlanSwitcherText, {
                                          [styles.disabledItem]: isNoPlanDisabledCon,
                                        })}
                                      >
                                        <Translation span text="jbp-planning-no-plan-switcher" />
                                      </div>
                                    </div>
                                  </>
                                )}
                                {isShowPartnersCompletenessForContractualPlan && (
                                  <div
                                    className={cn(styles.partnersCompleteness, {
                                      [styles.partnersCompletenessAdjust]:
                                        isAdjustPartnersCompleteness,
                                    })}
                                  >
                                    <br />
                                    <PartnersCompletenessField
                                      translationTag={completenessTag}
                                      partnersCompleteness={completenessItem}
                                      onClick={onPartnersCompletenessClick}
                                    />
                                  </div>
                                )}
                              </td>
                              {renderQContr(
                                idx,
                                isOverall,
                                -fyFq,
                                isEditAllowed,
                                false,
                                'c',
                                isNoPlanCon
                              )}
                              {renderQContr(
                                idx,
                                isOverall,
                                fyFq,
                                isEditAllowed,
                                false,
                                'c',
                                isNoPlanCon
                              )}
                              {fQuarters.map((q) =>
                                renderQContr(
                                  idx,
                                  isOverall,
                                  q,
                                  isEditAllowed,
                                  false,
                                  'c',
                                  isNoPlanCon
                                )
                              )}
                              {isShowFutureYears &&
                                renderQContr(
                                  idx,
                                  isOverall,
                                  fyFq + 1,
                                  isEditAllowed,
                                  false,
                                  'c',
                                  isNoPlanCon
                                )}
                              {isShowFutureYears &&
                                renderQContr(
                                  idx,
                                  isOverall,
                                  fyFq + 2,
                                  isEditAllowed,
                                  false,
                                  'c',
                                  isNoPlanCon
                                )}
                            </tr>
                          )}
                          {isShowContrTrans && (
                            <tr key={`${uniqueKey}-${idx}-2`} className={styles.contractualRow}>
                              <td
                                className={cn(
                                  { [styles.catTitle]: !isEditRow },
                                  { [styles.catTitleEdit]: isEditRow },
                                  { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                                  { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                                  { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                                  { [styles.catL3p]: isL3 },
                                  { [styles.catL2]: !isOverall && !isL3 },
                                  { [styles.catL3]: isL3SubCat && !isEditAllowed },
                                  { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                                )}
                              >
                                <Translation span text="jbp-planning-contractual-transactional" />
                              </td>
                              {renderQContr(
                                idx,
                                isOverall,
                                -fyFq,
                                isEditAllowed,
                                false,
                                't',
                                isNoPlanCon
                              )}
                              {renderQContr(
                                idx,
                                isOverall,
                                fyFq,
                                isEditAllowed,
                                false,
                                't',
                                isNoPlanCon
                              )}
                              {fQuarters.map((q) =>
                                renderQContr(
                                  idx,
                                  isOverall,
                                  q,
                                  isEditAllowed,
                                  false,
                                  't',
                                  isNoPlanCon
                                )
                              )}
                              {isShowFutureYears &&
                                renderQContr(
                                  idx,
                                  isOverall,
                                  fyFq + 1,
                                  isEditAllowed,
                                  false,
                                  't',
                                  isNoPlanCon
                                )}
                              {isShowFutureYears &&
                                renderQContr(
                                  idx,
                                  isOverall,
                                  fyFq + 2,
                                  isEditAllowed,
                                  false,
                                  't',
                                  isNoPlanCon
                                )}
                            </tr>
                          )}
                        </>
                      )}

                      {isShowSoB && (
                        <tr
                          key={`jbp-planning-sob-${subCat}-${idx}`}
                          className={cn(styles.contractualRow, styles.sobRow)}
                        >
                          <td
                            className={cn(
                              { [styles.catTitle]: !isEditSoB },
                              { [styles.sobTitleEdit]: isEditSoB },
                              { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                              { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                              { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                              { [styles.catL3p]: isL3 },
                              { [styles.catL2]: !isOverall && !isL3 },
                              { [styles.catL3]: isL3SubCat && !isEditAllowed },
                              { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                            )}
                          >
                            <Translation span text="jbp-planning-sob-row" />
                          </td>
                          {renderSoB(idx, isOverall, -fyFq, isEditAllowed, false, isNoPlan, false)}
                          {renderSoB(idx, isOverall, fyFq, isEditAllowed, false, isNoPlan, false)}
                          {fQuarters.map((q) =>
                            renderSoB(idx, isOverall, q, isEditAllowed, false, isNoPlan, false)
                          )}
                          {isShowFutureYears &&
                            renderSoB(
                              idx,
                              isOverall,
                              fyFq + 1,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false
                            )}
                          {isShowFutureYears &&
                            renderSoB(
                              idx,
                              isOverall,
                              fyFq + 2,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false
                            )}
                        </tr>
                      )}

                      {isShowGlobalSoB && (
                        <tr
                          key={`jbp-planning-sob-rollup-${subCat}-${idx}`}
                          className={cn(styles.contractualRow, styles.rollupRow)}
                        >
                          <td
                            className={cn(
                              { [styles.catTitle]: !isEditRow },
                              { [styles.catTitleEdit]: isEditRow },
                              { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                              { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                              { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                              { [styles.catL3p]: isL3 },
                              {
                                [styles.catL2]:
                                  (!isOverall && !isL3) || (isShowNoSplit && isOverall),
                              },
                              {
                                [styles.catL3]:
                                  (isL3SubCat && !isEditAllowed) || (isShowNoSplit && isL3Overall),
                              },
                              { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                            )}
                          >
                            <Translation text="jbp-planning-sob-rollup" span actionsInside />
                          </td>
                          {renderSoB(idx, isOverall, -fyFq, isEditAllowed, false, isNoPlan, true)}
                          {renderSoB(idx, isOverall, fyFq, isEditAllowed, false, isNoPlan, true)}
                          {fQuarters.map((q) =>
                            renderSoB(idx, isOverall, q, isEditAllowed, false, isNoPlan, true)
                          )}
                          {isShowFutureYears &&
                            renderSoB(
                              idx,
                              isOverall,
                              fyFq + 1,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              true
                            )}
                          {isShowFutureYears &&
                            renderSoB(
                              idx,
                              isOverall,
                              fyFq + 2,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              true
                            )}
                        </tr>
                      )}
                    </Fragment>
                  )
                })}
              </tbody>
            )}
            {isShowComposedReportCollapsedWarning && (
              <tfoot>
                <tr>
                  <th colSpan={planningColSpan}>
                    {props.showActuals && (
                      <div className={styles.infoContainer}>
                        <i
                          className={cn('kbase kbase-info-alt', styles.infoIcon)}
                          aria-hidden="true"
                        />
                        <span className={styles.composedReportLegend}>
                          <Translation text="jbp-planning-composed-report-warning" actionsInside />
                        </span>
                      </div>
                    )}
                  </th>
                </tr>
              </tfoot>
            )}
          </table>
        )}

        {isShowApplyBeforeUnits && renderApplySection()}

        {isShowUnitsSection && (
          <table
            className={cn(
              stylesTable.table,
              stylesCompensation.table,
              styles.table,
              styles.unitsTable
            )}
          >
            {isShowCurrencyBlock && (
              <caption>
                <WidgetHeader className={cn({ [styles.unitsHeader]: !isEditAllowed })}>
                  {categoryUnitsHeaderKey}
                </WidgetHeader>
              </caption>
            )}
            <thead>
              {!!props.isQuarterlyBusinessReviewMode && (
                <tr>
                  <th colSpan={planningColSpan}>
                    <div className={styles.switchersContainer}>
                      {isShowCurrencyCtrl && <CurrenciesButtons />}
                      {isShowNetNdpCtrl && <ActualsTypeButtons />}
                    </div>
                  </th>
                </tr>
              )}
              {isShowControlsBeforeUnits && (
                <tr>
                  <th colSpan={planningColSpan}>
                    <div className={styles.switchersContainer}>
                      <div className={styles.switcher}>
                        <Switch
                          padding
                          disabled={!!props.dataSetInfo.IsOnlyQuarterlyPlanning}
                          checked={
                            !!props.dataSetInfo.IsOnlyQuarterlyPlanning ||
                            isOn(currentCat, 'quarter', IS_QUARTER_DEFAULT)
                          }
                          onChange={() => setSetting(currentCat, 'quarter')}
                        />
                        <div className={styles.switcherText}>
                          <Translation span text="jbp-planning-quarter-switcher" />
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
              )}
              {isUseContractuals && (
                <tr className={styles.splitPlanningRow}>
                  <th colSpan={planningColSpan}>
                    <div className={styles.splitPlanningContainer}>
                      <SplitPlanningSwitcher splitType={splitType} setSplitType={setSplitType} />
                      {isShowAllSplitsCtrl && (
                        <div className={styles.splitPlanningItem}>
                          <Checkbox
                            checked={isShowAllSplits}
                            onChange={() => setIsShowAllSplits((val) => !val)}
                            label={
                              <Translation text={'jbp-planning-show-contr-trans-switcher'} span />
                            }
                          />
                        </div>
                      )}
                    </div>
                  </th>
                </tr>
              )}
              {!isPartnerUser && isShowMapRow && (
                <MapRowStandard
                  mapData={props.mapData}
                  fyear={fyear}
                  currentCat={currentCat}
                  tag="jbp-market-growth-guidance-units"
                  isUnits={true}
                  isShowCalcActuals={isShowCalcActuals}
                  isShowFutureYears={isShowFutureYears}
                  isComposedReport={!!props.composedReportMode}
                  hideIfEmpty
                />
              )}
              <CategoryHeaderStandard
                translationKey="jbp-planning-header-units"
                fyear={fyear}
                isShowCalcActuals={isShowCalcActuals}
                isShowFutureYears={isShowFutureYears}
                currentFQuarter={jbpSettings.currentFQuarter}
                isComposedReport={!!props.composedReportMode}
                periodFQuarters={fQuarters}
                isQbrYtd={props.isQuarterlyBusinessReviewMode}
              />
            </thead>
            <tbody>
              {props.formats.map((format, idx) => {
                const cat = format.Category
                const subCat = format.SubCategory
                const isOverall = subCat === OVERALL_CATEGORY || !subCat
                const isShowCollapseButton =
                  isCollapseAllowed && isEditAllowed && !isOverallOnly && isOverall

                const l3Cat = format.L3Category
                const isL3Overall = l3Cat === OVERALL_CATEGORY
                const isL3 = !!l3Cat

                const isIsCatExpanded = getIsExpandedByFlags({
                  settings: format.Settings,
                  flagsState: props.partnerFlagsState,
                })

                const isL3Collapsed =
                  getIsCollapsedL3Category(targetsItems, fyear, subCat) && !isIsCatExpanded
                const isShowL3CollapseButton =
                  isL3 && isL3Overall && isEditAllowed && !isIsCatExpanded
                const isShowL3Border = isL3 && (!isL3Overall || (isL3Overall && !isL3Collapsed))
                const isL3SubCat = isL3 && !isL3Overall
                const l3Idx = getL3Index(format)

                const fyFq = PLANNING_BY_FY_FQ
                const isNoPlan = false
                const isNoPlanCon = false

                const uniqueCategory = isOverall ? cat : subCat
                const uniqueKey = `jbp-planning-contractual-${uniqueCategory}`

                const isEditRow = isEditAllowed && (!isOverall || isFixedCollapsed)

                const isEmptyRow = !getRowSum(idx, true)
                const isSkipCurrentCategory =
                  (isFixedCollapsed && !isOverall) ||
                  (isL3Collapsed && !isL3Overall) ||
                  (!format.IsUnitsAvailable && !props.isQuarterlyBusinessReviewMode) ||
                  (isEmptyRow &&
                    !isOverall &&
                    !isEditMode &&
                    !props.composedReportMode &&
                    !props.isQuarterlyBusinessReviewMode)

                const sType = splitType === 'Contractual' ? 'c' : 't'
                if (isSkipCurrentCategory) {
                  return (
                    <Fragment key={`jbp-target-actuals-${subCat}-units-${idx}-hided`}></Fragment>
                  )
                }

                // Old clause for Global: !!partnerInfo?.IsGlobal && !isOverall
                const isHideCategoryToolTip = false

                return (
                  <Fragment key={`jbp-target-actuals-rows-${uniqueKey}-units-${idx}`}>
                    <tr key={`jbp-target-actuals-${subCat}-units-${idx}`}>
                      <td
                        className={cn(
                          styles.totalCell,
                          { [styles.catTitle]: !isEditRow },
                          { [styles.catTitleEdit]: isEditRow },
                          { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                          { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                          { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                          { [styles.catL3p]: isL3 },
                          { [styles.catL2]: !isOverall && !isL3 },
                          { [styles.catL3]: isL3SubCat && !isEditAllowed },
                          { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                        )}
                      >
                        {isShowCollapseButton && (
                          <div className={styles.categoryTitle}>
                            <span
                              className={styles.icon_expanded}
                              onClick={toggleIsCollapseCategory}
                            >
                              <i
                                className={cn('kbase', {
                                  'kbase-compress': !isFixedCollapsed,
                                  'kbase-expand': isFixedCollapsed,
                                })}
                                style={{ marginRight: '8px' }}
                                aria-hidden="true"
                              />
                              &nbsp;
                              <CategoryTitle
                                category={cat}
                                subCategory={subCat}
                                l3Category={l3Cat}
                                tip={format.PopupComment}
                                tipPrefix={globalCategoryTipPrefix}
                                isHideTooltip={isHideCategoryToolTip}
                              />
                            </span>
                            <CategorySubTitleStandard
                              isShowSubTitles={isOverall && !props.composedReportMode}
                              isShowQuotas={props.showQuota}
                              isShowActuals={props.showActuals}
                              isEditRow={isEditRow}
                            />
                          </div>
                        )}
                        {isShowL3CollapseButton && (
                          <span
                            className={styles.icon_expanded}
                            onClick={() => {
                              setIsL3Collapsed(idx, !isL3Collapsed, fyear)
                            }}
                          >
                            <i
                              className={cn('kbase', {
                                'kbase-compress': !isL3Collapsed,
                                'kbase-expand': isL3Collapsed,
                              })}
                              style={{ marginRight: '8px' }}
                              aria-hidden="true"
                            ></i>
                            &nbsp;
                            <CategoryTitle
                              category={cat}
                              subCategory={subCat}
                              l3Category={l3Cat}
                              tip={format.PopupComment}
                              tipPrefix={globalCategoryTipPrefix}
                              isHideTooltip={isHideCategoryToolTip}
                            />
                          </span>
                        )}
                        {!isShowCollapseButton && !isShowL3CollapseButton && (
                          <div className={styles.categoryTitle}>
                            <CategoryTitle
                              category={cat}
                              subCategory={subCat}
                              l3Category={l3Cat}
                              tip={format.PopupComment}
                              tipPrefix={globalCategoryTipPrefix}
                              isHideTooltip={isHideCategoryToolTip}
                            />
                            <CategorySubTitleStandard
                              isShowSubTitles={isOverall && !props.composedReportMode}
                              isShowQuotas={props.showQuota}
                              isShowActuals={props.showActuals}
                              isEditRow={isEditRow}
                            />
                          </div>
                        )}
                      </td>
                      {isNoSplitPlans
                        ? renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            -fyFq,
                            isEditAllowed,
                            true,
                            isNoPlan,
                            false,
                            false
                          )
                        : renderQContr(
                            idx,
                            isOverall,
                            -fyFq,
                            isEditAllowed,
                            true,
                            sType,
                            isNoPlanCon
                          )}
                      {isNoSplitPlans
                        ? renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            fyFq,
                            isEditAllowed,
                            true,
                            isNoPlan,
                            false,
                            false
                          )
                        : renderQContr(
                            idx,
                            isOverall,
                            fyFq,
                            isEditAllowed,
                            true,
                            sType,
                            isNoPlanCon
                          )}
                      {fQuarters.map((q) =>
                        isNoSplitPlans
                          ? renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              q,
                              isEditAllowed,
                              true,
                              isNoPlan,
                              false,
                              false
                            )
                          : renderQContr(idx, isOverall, q, isEditAllowed, true, sType, isNoPlanCon)
                      )}
                      {isShowFutureYears &&
                        (isNoSplitPlans
                          ? renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq + 1,
                              isEditAllowed,
                              true,
                              isNoPlan,
                              false,
                              false
                            )
                          : renderQContr(
                              idx,
                              isOverall,
                              fyFq + 1,
                              isEditAllowed,
                              true,
                              sType,
                              isNoPlanCon
                            ))}
                      {isShowFutureYears &&
                        (isNoSplitPlans
                          ? renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq + 2,
                              isEditAllowed,
                              true,
                              isNoPlan,
                              false,
                              false
                            )
                          : renderQContr(
                              idx,
                              isOverall,
                              fyFq + 2,
                              isEditAllowed,
                              true,
                              sType,
                              isNoPlanCon
                            ))}
                    </tr>

                    {isUseContractuals && (
                      <>
                        {isShowContrTrans && (
                          <tr key={`${uniqueKey}-${idx}-units`} className={styles.contractualRow}>
                            <td
                              className={cn(
                                { [styles.catTitle]: !isEditRow },
                                { [styles.catTitleEdit]: isEditRow },
                                { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                                { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                                { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                                { [styles.catL3p]: isL3 },
                                { [styles.catL2]: !isOverall && !isL3 },
                                { [styles.catL3]: isL3SubCat && !isEditAllowed },
                                { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                              )}
                            >
                              <Translation span text="jbp-planning-contractual-contractual" />
                            </td>
                            {renderQContr(
                              idx,
                              isOverall,
                              -fyFq,
                              isEditAllowed,
                              true,
                              'c',
                              isNoPlanCon
                            )}
                            {renderQContr(
                              idx,
                              isOverall,
                              fyFq,
                              isEditAllowed,
                              true,
                              'c',
                              isNoPlanCon
                            )}
                            {fQuarters.map((q) =>
                              renderQContr(idx, isOverall, q, isEditAllowed, true, 'c', isNoPlanCon)
                            )}
                            {isShowFutureYears &&
                              renderQContr(
                                idx,
                                isOverall,
                                fyFq + 1,
                                isEditAllowed,
                                true,
                                'c',
                                isNoPlanCon
                              )}
                            {isShowFutureYears &&
                              renderQContr(
                                idx,
                                isOverall,
                                fyFq + 2,
                                isEditAllowed,
                                true,
                                'c',
                                isNoPlanCon
                              )}
                          </tr>
                        )}
                        {isShowContrTrans && (
                          <tr key={`${uniqueKey}-${idx}-units-2`} className={styles.contractualRow}>
                            <td
                              className={cn(
                                { [styles.catTitle]: !isEditRow },
                                { [styles.catTitleEdit]: isEditRow },
                                { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                                { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                                { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                                { [styles.catL3p]: isL3 },
                                { [styles.catL2]: !isOverall && !isL3 },
                                { [styles.catL3]: isL3SubCat && !isEditAllowed },
                                { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                              )}
                            >
                              <Translation span text="jbp-planning-contractual-transactional" />
                            </td>
                            {renderQContr(
                              idx,
                              isOverall,
                              -fyFq,
                              isEditAllowed,
                              true,
                              't',
                              isNoPlanCon
                            )}
                            {renderQContr(
                              idx,
                              isOverall,
                              fyFq,
                              isEditAllowed,
                              true,
                              't',
                              isNoPlanCon
                            )}
                            {fQuarters.map((q) =>
                              renderQContr(idx, isOverall, q, isEditAllowed, true, 't', isNoPlanCon)
                            )}
                            {isShowFutureYears &&
                              renderQContr(
                                idx,
                                isOverall,
                                fyFq + 1,
                                isEditAllowed,
                                true,
                                't',
                                isNoPlanCon
                              )}
                            {isShowFutureYears &&
                              renderQContr(
                                idx,
                                isOverall,
                                fyFq + 2,
                                isEditAllowed,
                                true,
                                't',
                                isNoPlanCon
                              )}
                          </tr>
                        )}
                      </>
                    )}
                  </Fragment>
                )
              })}
            </tbody>
          </table>
        )}

        {isShowApplySection && renderApplySection()}

        {/** -------------------- Render dialogs ----------------------- */}

        <ConfirmNotApplicableDialog
          isShowDialog={isShowConfirmNotApplicableDialog}
          category={t(currentCat)}
          onConfirm={confirmNotApplicable}
          onClose={cancelNotApplicable}
        />

        <ModalDialog
          show={isShowSignDialogNA}
          size={'sm'}
          content={CommitmentChangeDialog}
          header={() => (
            <WidgetHeader className={styles.modalDialogHeader}>jbp-confirm-changes</WidgetHeader>
          )}
          contentProps={{
            partnerId: partnerId,
            fyear: fyear,
            programType: buttonCurrType,
            metrics: props.metrics,
            onApply: async () => {
              setIsShowSignDialogNA(false)

              await onChangeNotApplicable()
            },
            onCancel: () => setIsShowSignDialogNA(false),
          }}
          onClose={() => setIsShowSignDialogNA(false)}
        />

        <ModalDialog
          show={isShowRateDialog}
          size={'sm'}
          content={TypeChangeDialog}
          contentProps={{
            message:
              "The targets you've filled in are too low in comparison with partner's actuals. Keep in mind that you must fill in targets in $, not in K$. Do you confirm that the targets are correct?",
            onDiscard: () => {
              setIsShowRateDialog(false)
              discardChanges()
            },
            onApply: async () => {
              setIsShowRateDialog(false)

              const isSignatureWillBeDropped =
                isNeedToShowSignDialog && !isOverallValueNotChanged(partnerInfo)

              if (isSignatureWillBeDropped) {
                setIsShowSignDialog(true)
              } else if (isSwitchersChanged) {
                setIsShowConfirmSwitchersChangeDialog(true)
              } else {
                await applyChanges(targetsItems)
              }
            },
            onCancel: () => setIsShowRateDialog(false),
          }}
          onClose={() => setIsShowRateDialog(false)}
        />

        <ModalDialog
          show={isShowSignDialog}
          size={'sm'}
          content={CommitmentChangeDialog}
          header={() => (
            <WidgetHeader className={styles.modalDialogHeader}>jbp-confirm-changes</WidgetHeader>
          )}
          contentProps={{
            partnerId: partnerId,
            fyear: fyear,
            programType: buttonCurrType,
            metrics: props.metrics,
            onDiscard: () => {
              setIsShowSignDialog(false)
              discardChanges()
            },
            onApply: async () => {
              setIsShowSignDialog(false)

              if (isSwitchersChanged) {
                setIsShowConfirmSwitchersChangeDialog(true)
              } else {
                await applyChanges(targetsItems)
              }
            },
            onCancel: () => setIsShowSignDialog(false),
          }}
          onClose={() => setIsShowSignDialog(false)}
        />

        <ConfirmSwitchersChangeDialog
          isShowDialog={isShowConfirmSwitchersChangeDialog}
          currCurrency={props.originalCurrency}
          currActualsValueType={props.originalActualsValueType}
          currency={currency}
          actualsValueType={currentValueType}
          onConfirm={async () => {
            setIsShowConfirmSwitchersChangeDialog(false)
            await applyChanges(targetsItems)
          }}
          onClose={() => {
            setIsShowConfirmSwitchersChangeDialog(false)
          }}
        />

        <EditCommentDialog
          isShowDialog={!!editCommentEditor}
          currentEditComment={editCommentEditor?.comment || ''}
          onApply={async (value: any) => {
            if (editCommentEditor) {
              setComment(
                editCommentEditor.index,
                value,
                editCommentEditor.year,
                editCommentEditor.q
              )
            }

            setCommentEditor(undefined)
          }}
          onCancel={() => {
            setCommentEditor(undefined)
          }}
        />

        <PartnersWithoutSoBDialog
          isShowDialog={isShowPartnersWithoutSoBDialog}
          partnerIds={partnersWithoutSoBIds}
          onConfirm={async () => {
            setIsShowPartnersWithoutSoBDialog(false)
            setPartnersWithoutSoBIds('')
          }}
          onClose={() => {
            setIsShowPartnersWithoutSoBDialog(false)
            setPartnersWithoutSoBIds('')
          }}
        />

        <PartnersCompletenessDialog
          isShowDialog={!!partnersCompleteness}
          partnersCompleteness={partnersCompleteness}
          onConfirm={async () => {
            setPartnersCompleteness(undefined)
          }}
          onClose={() => {
            setPartnersCompleteness(undefined)
          }}
        />
      </Controller>
    </div>
  )
}
